export const paintColors = [
    "rgb(239, 242, 236)",
    "rgb(244, 241, 234)",
    "rgb(241, 240, 231)",
    "rgb(249, 248, 233)",
    "rgb(241, 241, 228)",
    "rgb(239, 237, 220)",
    "rgb(240, 237, 224)",
    "rgb(246, 237, 221)",
    "rgb(242, 235, 221)",
    "rgb(230, 225, 214)",
    "rgb(228, 220, 206)",
    "rgb(230, 220, 207)",
    "rgb(228, 222, 207)",
    "rgb(234, 230, 209)",
    "rgb(223, 224, 206)",
    "rgb(218, 211, 191)",
    "rgb(232, 220, 196)",
    "rgb(222, 205, 178)",
    "rgb(213, 202, 176)",
    "rgb(188, 179, 162)",
    "rgb(152, 134, 105)",
    "rgb(149, 129, 102)",
    "rgb(126, 103, 78)",
    "rgb(116, 97, 71)",
    "rgb(179, 151, 121)",
    "rgb(199, 177, 152)",
    "rgb(185, 163, 139)",
    "rgb(190, 171, 150)",
    "rgb(192, 178, 153)",
    "rgb(182, 167, 150)",
    "rgb(160, 147, 131)",
    "rgb(141, 112, 94)",
    "rgb(115, 87, 66)",
    "rgb(96, 78, 68)",
    "rgb(89, 67, 59)",
    "rgb(61, 46, 44)",
    "rgb(197, 170, 151)",
    "rgb(219, 195, 175)",
    "rgb(222, 191, 160)",
    "rgb(213, 182, 150)",
    "rgb(218, 177, 146)",
    "rgb(212, 165, 131)",
    "rgb(204, 154, 119)",
    "rgb(164, 104, 63)",
    "rgb(185, 117, 81)",
    "rgb(196, 118, 65)",
    "rgb(151, 91, 59)",
    "rgb(129, 80, 50)",
    "rgb(198, 164, 141)",
    "rgb(240, 223, 211)",
    "rgb(249, 238, 228)",
    "rgb(233, 218, 213)",
    "rgb(220, 205, 195)",
    "rgb(161, 111, 105)",
    "rgb(125, 63, 47)",
    "rgb(172, 85, 64)",
    "rgb(179, 93, 81)",
    "rgb(139, 40, 41)",
    "rgb(140, 57, 63)",
    "rgb(119, 55, 56)",
    "rgb(245, 234, 207)",
    "rgb(243, 232, 208)",
    "rgb(243, 223, 189)",
    "rgb(238, 220, 190)",
    "rgb(239, 216, 179)",
    "rgb(253, 234, 190)",
    "rgb(235, 211, 169)",
    "rgb(208, 187, 147)",
    "rgb(217, 187, 136)",
    "rgb(186, 147, 88)",
    "rgb(176, 131, 86)",
    "rgb(197, 160, 121)",
    "rgb(218, 200, 155)",
    "rgb(201, 172, 111)",
    "rgb(188, 166, 120)",
    "rgb(195, 180, 148)",
    "rgb(206, 190, 150)",
    "rgb(196, 184, 158)",
    "rgb(172, 164, 141)",
    "rgb(178, 173, 142)",
    "rgb(162, 161, 127)",
    "rgb(181, 175, 143)",
    "rgb(198, 196, 152)",
    "rgb(173, 170, 111)",
    "rgb(200, 183, 122)",
    "rgb(181, 169, 93)",
    "rgb(214, 212, 185)",
    "rgb(178, 182, 151)",
    "rgb(152, 157, 121)",
    "rgb(164, 183, 147)",
    "rgb(179, 183, 160)",
    "rgb(134, 139, 117)",
    "rgb(200, 203, 183)",
    "rgb(164, 173, 159)",
    "rgb(116, 129, 114)",
    "rgb(84, 96, 79)",
    "rgb(202, 213, 201)",
    "rgb(188, 196, 188)",
    "rgb(138, 161, 153)",
    "rgb(137, 158, 155)",
    "rgb(111, 137, 142)",
    "rgb(62, 98, 95)",
    "rgb(160, 185, 194)",
    "rgb(83, 119, 136)",
    "rgb(79, 128, 147)",
    "rgb(59, 101, 126)",
    "rgb(172, 194, 205)",
    "rgb(214, 226, 228)",
    "rgb(164, 175, 181)",
    "rgb(130, 149, 158)",
    "rgb(114, 129, 136)",
    "rgb(87, 93, 95)",
    "rgb(70, 76, 85)",
    "rgb(146, 158, 169)",
    "rgb(187, 198, 209)",
    "rgb(117, 126, 147)",
    "rgb(157, 157, 167)",
    "rgb(123, 119, 127)",
    "rgb(173, 159, 171)",
    "rgb(150, 137, 151)",
    "rgb(215, 211, 214)",
    "rgb(205, 186, 182)",
    "rgb(197, 184, 188)",
    "rgb(181, 170, 176)",
    "rgb(149, 114, 126)",
    "rgb(112, 81, 96)",
    "rgb(125, 107, 116)",
    "rgb(122, 109, 112)",
    "rgb(87, 71, 79)",
    "rgb(70, 50, 52)",
    "rgb(88, 81, 77)",
    "rgb(131, 126, 124)",
    "rgb(213, 207, 204)",
    "rgb(183, 181, 179)",
    "rgb(166, 163, 161)",
    "rgb(208, 203, 195)",
    "rgb(190, 185, 174)",
    "rgb(187, 190, 185)",
    "rgb(191, 195, 195)",
    "rgb(160, 161, 159)",
    "rgb(135, 134, 132)",
    "rgb(137, 138, 132)",
    "rgb(134, 132, 126)",
    "rgb(132, 125, 111)",
    "rgb(203, 197, 177)",
    "rgb(176, 166, 144)",
    "rgb(134, 123, 105)",
    "rgb(222, 202, 173)",
    "rgb(193, 168, 136)",
    "rgb(161, 133, 98)",
    "rgb(217, 197, 172)",
    "rgb(201, 172, 140)",
    "rgb(183, 145, 108)",
    "rgb(219, 185, 162)",
    "rgb(203, 163, 135)",
    "rgb(178, 126, 97)",
    "rgb(217, 190, 174)",
    "rgb(196, 158, 136)",
    "rgb(184, 141, 118)",
    "rgb(164, 177, 175)",
    "rgb(140, 149, 145)",
    "rgb(123, 133, 128)",
    "rgb(165, 188, 183)",
    "rgb(117, 143, 137)",
    "rgb(91, 114, 106)",
    "rgb(163, 181, 187)",
    "rgb(135, 153, 159)",
    "rgb(103, 122, 128)",
    "rgb(200, 200, 195)",
    "rgb(183, 181, 173)",
    "rgb(154, 150, 141)",
    "rgb(194, 192, 187)",
    "rgb(181, 179, 175)",
    "rgb(163, 158, 151)",
    "rgb(202, 191, 176)",
    "rgb(184, 171, 155)",
    "rgb(160, 143, 125)",
    "rgb(191, 185, 175)",
    "rgb(183, 176, 164)",
    "rgb(166, 155, 142)",
    "rgb(211, 201, 190)",
    "rgb(196, 185, 175)",
    "rgb(170, 155, 142)",
    "rgb(237, 235, 225)",
    "rgb(243, 240, 224)",
    "rgb(234, 230, 209)",
    "rgb(255, 214, 204)",
    "rgb(255, 194, 183)",
    "rgb(253, 177, 164)",
    "rgb(249, 150, 134)",
    "rgb(244, 128, 108)",
    "rgb(235, 110, 91)",
    "rgb(226, 81, 61)",
    "rgb(248, 216, 205)",
    "rgb(249, 202, 193)",
    "rgb(252, 191, 179)",
    "rgb(248, 163, 147)",
    "rgb(240, 141, 126)",
    "rgb(238, 124, 109)",
    "rgb(221, 99, 78)",
    "rgb(248, 220, 208)",
    "rgb(255, 215, 203)",
    "rgb(250, 197, 180)",
    "rgb(246, 165, 141)",
    "rgb(242, 148, 121)",
    "rgb(240, 123, 96)",
    "rgb(227, 110, 75)",
    "rgb(248, 229, 213)",
    "rgb(246, 217, 200)",
    "rgb(248, 201, 184)",
    "rgb(242, 184, 165)",
    "rgb(232, 159, 132)",
    "rgb(217, 133, 104)",
    "rgb(207, 109, 83)",
    "rgb(248, 220, 210)",
    "rgb(239, 195, 184)",
    "rgb(234, 170, 155)",
    "rgb(225, 145, 125)",
    "rgb(212, 121, 101)",
    "rgb(183, 97, 80)",
    "rgb(159, 86, 70)",
    "rgb(241, 212, 202)",
    "rgb(234, 202, 194)",
    "rgb(223, 181, 171)",
    "rgb(215, 156, 143)",
    "rgb(204, 134, 117)",
    "rgb(179, 108, 89)",
    "rgb(137, 78, 70)",
    "rgb(242, 214, 204)",
    "rgb(237, 201, 191)",
    "rgb(232, 186, 173)",
    "rgb(219, 165, 147)",
    "rgb(194, 134, 116)",
    "rgb(152, 96, 88)",
    "rgb(136, 85, 76)",
    "rgb(243, 219, 205)",
    "rgb(239, 207, 194)",
    "rgb(231, 190, 173)",
    "rgb(227, 182, 166)",
    "rgb(217, 159, 136)",
    "rgb(210, 141, 109)",
    "rgb(185, 110, 83)",
    "rgb(247, 228, 208)",
    "rgb(248, 214, 194)",
    "rgb(245, 204, 180)",
    "rgb(241, 193, 165)",
    "rgb(230, 169, 132)",
    "rgb(217, 146, 110)",
    "rgb(197, 120, 83)",
    "rgb(248, 224, 206)",
    "rgb(247, 217, 197)",
    "rgb(247, 209, 184)",
    "rgb(243, 193, 167)",
    "rgb(233, 165, 130)",
    "rgb(222, 138, 100)",
    "rgb(193, 107, 71)",
    "rgb(247, 217, 197)",
    "rgb(250, 198, 173)",
    "rgb(246, 188, 162)",
    "rgb(243, 167, 134)",
    "rgb(228, 143, 106)",
    "rgb(209, 114, 75)",
    "rgb(179, 88, 64)",
    "rgb(249, 228, 210)",
    "rgb(253, 221, 200)",
    "rgb(253, 208, 186)",
    "rgb(249, 173, 138)",
    "rgb(248, 149, 108)",
    "rgb(246, 134, 92)",
    "rgb(241, 119, 76)",
    "rgb(248, 231, 212)",
    "rgb(250, 226, 204)",
    "rgb(251, 218, 192)",
    "rgb(255, 203, 169)",
    "rgb(251, 183, 138)",
    "rgb(253, 166, 117)",
    "rgb(248, 132, 70)",
    "rgb(248, 231, 209)",
    "rgb(251, 227, 201)",
    "rgb(251, 218, 189)",
    "rgb(249, 209, 179)",
    "rgb(245, 198, 161)",
    "rgb(239, 176, 133)",
    "rgb(209, 124, 82)",
    "rgb(247, 225, 205)",
    "rgb(242, 213, 193)",
    "rgb(241, 207, 183)",
    "rgb(221, 171, 135)",
    "rgb(219, 156, 115)",
    "rgb(190, 120, 81)",
    "rgb(157, 97, 65)",
    "rgb(247, 225, 201)",
    "rgb(242, 214, 184)",
    "rgb(242, 203, 168)",
    "rgb(232, 180, 137)",
    "rgb(223, 162, 116)",
    "rgb(213, 147, 99)",
    "rgb(203, 132, 85)",
    "rgb(248, 233, 207)",
    "rgb(247, 223, 192)",
    "rgb(248, 215, 178)",
    "rgb(241, 202, 162)",
    "rgb(231, 184, 138)",
    "rgb(222, 158, 102)",
    "rgb(209, 135, 79)",
    "rgb(251, 225, 194)",
    "rgb(252, 217, 175)",
    "rgb(255, 210, 166)",
    "rgb(245, 193, 140)",
    "rgb(238, 168, 105)",
    "rgb(240, 164, 98)",
    "rgb(216, 139, 76)",
    "rgb(249, 236, 211)",
    "rgb(250, 228, 199)",
    "rgb(255, 218, 176)",
    "rgb(254, 207, 159)",
    "rgb(250, 188, 129)",
    "rgb(254, 177, 110)",
    "rgb(248, 150, 72)",
    "rgb(251, 231, 207)",
    "rgb(249, 222, 193)",
    "rgb(253, 211, 172)",
    "rgb(255, 200, 156)",
    "rgb(254, 182, 129)",
    "rgb(253, 164, 104)",
    "rgb(246, 141, 65)",
    "rgb(250, 233, 197)",
    "rgb(251, 225, 179)",
    "rgb(254, 221, 169)",
    "rgb(253, 208, 143)",
    "rgb(252, 189, 108)",
    "rgb(249, 173, 88)",
    "rgb(250, 158, 73)",
    "rgb(253, 236, 201)",
    "rgb(255, 228, 178)",
    "rgb(254, 225, 176)",
    "rgb(255, 218, 160)",
    "rgb(254, 202, 132)",
    "rgb(255, 197, 121)",
    "rgb(255, 169, 79)",
    "rgb(246, 233, 207)",
    "rgb(254, 225, 182)",
    "rgb(255, 220, 175)",
    "rgb(251, 213, 165)",
    "rgb(246, 196, 131)",
    "rgb(241, 187, 120)",
    "rgb(228, 155, 81)",
    "rgb(247, 235, 203)",
    "rgb(248, 228, 192)",
    "rgb(246, 220, 177)",
    "rgb(244, 208, 157)",
    "rgb(236, 189, 128)",
    "rgb(226, 169, 100)",
    "rgb(198, 131, 65)",
    "rgb(248, 232, 198)",
    "rgb(247, 226, 171)",
    "rgb(253, 220, 149)",
    "rgb(253, 207, 116)",
    "rgb(255, 202, 100)",
    "rgb(246, 182, 80)",
    "rgb(224, 164, 75)",
    "rgb(247, 234, 197)",
    "rgb(245, 227, 182)",
    "rgb(242, 220, 171)",
    "rgb(247, 216, 152)",
    "rgb(242, 203, 128)",
    "rgb(237, 180, 94)",
    "rgb(214, 158, 79)",
    "rgb(247, 237, 212)",
    "rgb(243, 231, 201)",
    "rgb(242, 221, 182)",
    "rgb(235, 208, 161)",
    "rgb(230, 197, 140)",
    "rgb(228, 179, 112)",
    "rgb(209, 161, 92)",
    "rgb(248, 238, 214)",
    "rgb(245, 227, 193)",
    "rgb(238, 214, 173)",
    "rgb(226, 195, 140)",
    "rgb(214, 176, 113)",
    "rgb(192, 151, 83)",
    "rgb(177, 136, 74)",
    "rgb(246, 234, 195)",
    "rgb(243, 226, 181)",
    "rgb(238, 216, 165)",
    "rgb(232, 206, 142)",
    "rgb(226, 197, 121)",
    "rgb(223, 185, 103)",
    "rgb(202, 156, 67)",
    "rgb(244, 236, 213)",
    "rgb(242, 231, 204)",
    "rgb(239, 224, 184)",
    "rgb(233, 212, 162)",
    "rgb(225, 200, 136)",
    "rgb(215, 188, 117)",
    "rgb(195, 159, 85)",
    "rgb(246, 238, 209)",
    "rgb(245, 233, 197)",
    "rgb(242, 227, 176)",
    "rgb(235, 218, 158)",
    "rgb(226, 203, 133)",
    "rgb(218, 192, 114)",
    "rgb(195, 155, 78)",
    "rgb(243, 232, 204)",
    "rgb(238, 222, 184)",
    "rgb(233, 215, 172)",
    "rgb(222, 203, 155)",
    "rgb(206, 180, 122)",
    "rgb(186, 154, 92)",
    "rgb(159, 131, 74)",
    "rgb(238, 230, 207)",
    "rgb(228, 218, 188)",
    "rgb(214, 201, 167)",
    "rgb(203, 185, 141)",
    "rgb(189, 165, 117)",
    "rgb(161, 140, 96)",
    "rgb(128, 109, 71)",
    "rgb(236, 228, 208)",
    "rgb(223, 212, 188)",
    "rgb(210, 198, 169)",
    "rgb(192, 175, 141)",
    "rgb(163, 142, 103)",
    "rgb(130, 112, 79)",
    "rgb(124, 108, 79)",
    "rgb(229, 221, 197)",
    "rgb(222, 212, 184)",
    "rgb(211, 200, 170)",
    "rgb(207, 196, 165)",
    "rgb(194, 183, 152)",
    "rgb(173, 157, 125)",
    "rgb(152, 133, 103)",
    "rgb(242, 233, 205)",
    "rgb(233, 221, 187)",
    "rgb(223, 207, 167)",
    "rgb(207, 186, 134)",
    "rgb(186, 159, 101)",
    "rgb(166, 140, 85)",
    "rgb(151, 127, 79)",
    "rgb(239, 230, 200)",
    "rgb(230, 218, 179)",
    "rgb(219, 203, 157)",
    "rgb(202, 180, 123)",
    "rgb(198, 177, 120)",
    "rgb(178, 150, 88)",
    "rgb(158, 131, 71)",
    "rgb(245, 235, 203)",
    "rgb(237, 228, 194)",
    "rgb(226, 214, 171)",
    "rgb(219, 207, 162)",
    "rgb(210, 188, 130)",
    "rgb(203, 179, 118)",
    "rgb(177, 152, 86)",
    "rgb(244, 236, 215)",
    "rgb(237, 228, 203)",
    "rgb(232, 220, 188)",
    "rgb(218, 202, 162)",
    "rgb(201, 178, 129)",
    "rgb(194, 170, 120)",
    "rgb(178, 156, 104)",
    "rgb(244, 229, 183)",
    "rgb(235, 220, 162)",
    "rgb(235, 219, 154)",
    "rgb(226, 205, 130)",
    "rgb(211, 190, 102)",
    "rgb(203, 172, 86)",
    "rgb(172, 144, 79)",
    "rgb(244, 238, 210)",
    "rgb(248, 241, 207)",
    "rgb(248, 237, 187)",
    "rgb(244, 229, 161)",
    "rgb(231, 211, 130)",
    "rgb(215, 190, 105)",
    "rgb(199, 165, 72)",
    "rgb(245, 238, 205)",
    "rgb(244, 232, 191)",
    "rgb(242, 224, 160)",
    "rgb(236, 215, 138)",
    "rgb(235, 210, 129)",
    "rgb(229, 196, 105)",
    "rgb(209, 167, 72)",
    "rgb(251, 239, 198)",
    "rgb(254, 234, 182)",
    "rgb(251, 226, 161)",
    "rgb(244, 211, 128)",
    "rgb(239, 197, 100)",
    "rgb(240, 189, 81)",
    "rgb(227, 174, 75)",
    "rgb(251, 240, 207)",
    "rgb(252, 236, 194)",
    "rgb(253, 231, 177)",
    "rgb(250, 216, 150)",
    "rgb(246, 203, 122)",
    "rgb(248, 189, 88)",
    "rgb(229, 161, 58)",
    "rgb(249, 239, 205)",
    "rgb(253, 234, 183)",
    "rgb(254, 232, 166)",
    "rgb(252, 220, 145)",
    "rgb(251, 208, 113)",
    "rgb(253, 198, 81)",
    "rgb(255, 190, 71)",
    "rgb(251, 242, 199)",
    "rgb(254, 239, 179)",
    "rgb(255, 236, 163)",
    "rgb(255, 226, 130)",
    "rgb(254, 219, 103)",
    "rgb(255, 208, 49)",
    "rgb(255, 203, 38)",
    "rgb(251, 242, 198)",
    "rgb(253, 241, 183)",
    "rgb(253, 236, 163)",
    "rgb(250, 230, 133)",
    "rgb(254, 227, 106)",
    "rgb(252, 223, 98)",
    "rgb(255, 217, 82)",
    "rgb(249, 244, 214)",
    "rgb(249, 241, 197)",
    "rgb(251, 242, 185)",
    "rgb(251, 235, 159)",
    "rgb(248, 229, 130)",
    "rgb(249, 226, 102)",
    "rgb(255, 222, 58)",
    "rgb(250, 243, 203)",
    "rgb(251, 242, 188)",
    "rgb(253, 236, 158)",
    "rgb(248, 227, 126)",
    "rgb(251, 223, 97)",
    "rgb(248, 215, 80)",
    "rgb(241, 202, 52)",
    "rgb(248, 240, 210)",
    "rgb(250, 240, 198)",
    "rgb(245, 233, 175)",
    "rgb(244, 229, 157)",
    "rgb(242, 219, 119)",
    "rgb(242, 205, 85)",
    "rgb(229, 189, 60)",
    "rgb(249, 244, 198)",
    "rgb(249, 237, 170)",
    "rgb(247, 229, 134)",
    "rgb(244, 222, 101)",
    "rgb(237, 214, 90)",
    "rgb(238, 211, 80)",
    "rgb(227, 201, 58)",
    "rgb(250, 242, 185)",
    "rgb(249, 238, 169)",
    "rgb(248, 232, 144)",
    "rgb(249, 229, 124)",
    "rgb(242, 219, 88)",
    "rgb(233, 211, 75)",
    "rgb(211, 194, 62)",
    "rgb(248, 241, 198)",
    "rgb(245, 236, 183)",
    "rgb(239, 228, 165)",
    "rgb(237, 224, 156)",
    "rgb(232, 217, 136)",
    "rgb(227, 209, 110)",
    "rgb(206, 189, 72)",
    "rgb(247, 240, 210)",
    "rgb(243, 234, 194)",
    "rgb(235, 225, 178)",
    "rgb(231, 217, 159)",
    "rgb(220, 202, 137)",
    "rgb(209, 189, 105)",
    "rgb(192, 167, 84)",
    "rgb(237, 231, 199)",
    "rgb(231, 225, 186)",
    "rgb(220, 215, 168)",
    "rgb(214, 198, 138)",
    "rgb(197, 181, 116)",
    "rgb(180, 164, 89)",
    "rgb(174, 156, 75)",
    "rgb(246, 241, 206)",
    "rgb(244, 238, 194)",
    "rgb(239, 232, 177)",
    "rgb(228, 219, 156)",
    "rgb(218, 206, 123)",
    "rgb(200, 189, 97)",
    "rgb(175, 165, 75)",
    "rgb(242, 244, 203)",
    "rgb(237, 241, 187)",
    "rgb(225, 233, 156)",
    "rgb(217, 223, 124)",
    "rgb(212, 218, 94)",
    "rgb(207, 207, 75)",
    "rgb(203, 203, 54)",
    "rgb(233, 241, 196)",
    "rgb(227, 237, 181)",
    "rgb(218, 233, 162)",
    "rgb(205, 220, 122)",
    "rgb(198, 211, 92)",
    "rgb(168, 182, 85)",
    "rgb(150, 166, 79)",
    "rgb(230, 242, 208)",
    "rgb(226, 240, 195)",
    "rgb(221, 238, 188)",
    "rgb(210, 233, 166)",
    "rgb(203, 228, 147)",
    "rgb(166, 199, 104)",
    "rgb(156, 186, 92)",
    "rgb(236, 244, 204)",
    "rgb(226, 241, 187)",
    "rgb(213, 233, 153)",
    "rgb(191, 222, 121)",
    "rgb(171, 216, 107)",
    "rgb(150, 204, 85)",
    "rgb(121, 186, 67)",
    "rgb(227, 242, 210)",
    "rgb(217, 238, 197)",
    "rgb(208, 233, 186)",
    "rgb(197, 225, 173)",
    "rgb(174, 210, 139)",
    "rgb(159, 197, 122)",
    "rgb(132, 173, 89)",
    "rgb(221, 233, 208)",
    "rgb(211, 224, 192)",
    "rgb(192, 207, 169)",
    "rgb(168, 186, 138)",
    "rgb(156, 176, 124)",
    "rgb(132, 149, 99)",
    "rgb(99, 119, 74)",
    "rgb(221, 228, 209)",
    "rgb(213, 223, 204)",
    "rgb(208, 219, 197)",
    "rgb(193, 204, 178)",
    "rgb(170, 182, 150)",
    "rgb(137, 151, 115)",
    "rgb(99, 110, 82)",
    "rgb(204, 217, 199)",
    "rgb(187, 202, 181)",
    "rgb(171, 188, 166)",
    "rgb(148, 166, 141)",
    "rgb(113, 130, 108)",
    "rgb(92, 107, 92)",
    "rgb(82, 94, 82)",
    "rgb(206, 223, 212)",
    "rgb(192, 210, 192)",
    "rgb(175, 194, 174)",
    "rgb(156, 174, 152)",
    "rgb(137, 152, 127)",
    "rgb(118, 135, 111)",
    "rgb(87, 103, 79)",
    "rgb(214, 225, 214)",
    "rgb(207, 218, 205)",
    "rgb(192, 206, 195)",
    "rgb(180, 195, 182)",
    "rgb(152, 165, 148)",
    "rgb(116, 127, 108)",
    "rgb(87, 94, 80)",
    "rgb(227, 232, 221)",
    "rgb(211, 218, 203)",
    "rgb(188, 199, 184)",
    "rgb(168, 181, 163)",
    "rgb(141, 154, 134)",
    "rgb(116, 128, 107)",
    "rgb(89, 99, 82)",
    "rgb(210, 216, 200)",
    "rgb(202, 209, 192)",
    "rgb(186, 193, 174)",
    "rgb(166, 171, 147)",
    "rgb(148, 153, 129)",
    "rgb(124, 129, 105)",
    "rgb(98, 101, 80)",
    "rgb(224, 227, 199)",
    "rgb(214, 220, 186)",
    "rgb(203, 211, 174)",
    "rgb(186, 195, 163)",
    "rgb(172, 178, 143)",
    "rgb(151, 155, 115)",
    "rgb(129, 132, 93)",
    "rgb(229, 232, 211)",
    "rgb(213, 219, 192)",
    "rgb(200, 206, 174)",
    "rgb(175, 183, 143)",
    "rgb(150, 158, 111)",
    "rgb(120, 127, 86)",
    "rgb(111, 117, 81)",
    "rgb(227, 228, 205)",
    "rgb(219, 218, 191)",
    "rgb(204, 204, 174)",
    "rgb(186, 184, 145)",
    "rgb(163, 162, 118)",
    "rgb(131, 128, 88)",
    "rgb(119, 118, 78)",
    "rgb(222, 226, 203)",
    "rgb(215, 219, 192)",
    "rgb(205, 208, 175)",
    "rgb(196, 199, 165)",
    "rgb(176, 179, 137)",
    "rgb(158, 159, 112)",
    "rgb(139, 137, 94)",
    "rgb(218, 221, 205)",
    "rgb(211, 213, 197)",
    "rgb(196, 200, 178)",
    "rgb(185, 185, 162)",
    "rgb(164, 162, 136)",
    "rgb(134, 132, 104)",
    "rgb(126, 119, 91)",
    "rgb(231, 226, 204)",
    "rgb(223, 216, 191)",
    "rgb(207, 200, 171)",
    "rgb(181, 170, 134)",
    "rgb(153, 140, 102)",
    "rgb(124, 115, 82)",
    "rgb(110, 105, 79)",
    "rgb(236, 235, 215)",
    "rgb(226, 227, 204)",
    "rgb(220, 217, 189)",
    "rgb(204, 201, 164)",
    "rgb(181, 177, 134)",
    "rgb(159, 151, 105)",
    "rgb(146, 135, 90)",
    "rgb(225, 227, 191)",
    "rgb(216, 219, 174)",
    "rgb(210, 211, 162)",
    "rgb(193, 195, 135)",
    "rgb(162, 165, 101)",
    "rgb(157, 155, 99)",
    "rgb(145, 142, 86)",
    "rgb(233, 237, 211)",
    "rgb(225, 234, 203)",
    "rgb(212, 223, 187)",
    "rgb(204, 215, 170)",
    "rgb(189, 198, 142)",
    "rgb(167, 180, 119)",
    "rgb(141, 151, 91)",
    "rgb(216, 229, 194)",
    "rgb(208, 223, 182)",
    "rgb(187, 206, 161)",
    "rgb(167, 187, 129)",
    "rgb(150, 174, 110)",
    "rgb(138, 161, 105)",
    "rgb(111, 133, 85)",
    "rgb(225, 240, 211)",
    "rgb(202, 231, 193)",
    "rgb(192, 225, 185)",
    "rgb(163, 211, 147)",
    "rgb(150, 201, 133)",
    "rgb(115, 166, 87)",
    "rgb(96, 147, 84)",
    "rgb(222, 241, 204)",
    "rgb(207, 236, 186)",
    "rgb(184, 228, 161)",
    "rgb(164, 218, 133)",
    "rgb(133, 204, 108)",
    "rgb(104, 181, 89)",
    "rgb(82, 165, 73)",
    "rgb(202, 227, 198)",
    "rgb(193, 223, 192)",
    "rgb(171, 209, 173)",
    "rgb(142, 187, 143)",
    "rgb(123, 173, 123)",
    "rgb(91, 143, 95)",
    "rgb(78, 115, 87)",
    "rgb(212, 238, 210)",
    "rgb(198, 234, 201)",
    "rgb(179, 226, 186)",
    "rgb(170, 223, 180)",
    "rgb(137, 198, 143)",
    "rgb(104, 179, 116)",
    "rgb(41, 144, 81)",
    "rgb(188, 237, 215)",
    "rgb(172, 231, 206)",
    "rgb(162, 224, 198)",
    "rgb(135, 211, 179)",
    "rgb(118, 201, 163)",
    "rgb(91, 186, 145)",
    "rgb(50, 152, 108)",
    "rgb(216, 240, 227)",
    "rgb(200, 234, 217)",
    "rgb(182, 227, 207)",
    "rgb(150, 210, 183)",
    "rgb(121, 191, 157)",
    "rgb(82, 161, 123)",
    "rgb(71, 147, 110)",
    "rgb(178, 232, 213)",
    "rgb(162, 224, 204)",
    "rgb(138, 215, 190)",
    "rgb(103, 192, 161)",
    "rgb(60, 167, 130)",
    "rgb(36, 138, 103)",
    "rgb(49, 107, 88)",
    "rgb(213, 237, 223)",
    "rgb(204, 234, 223)",
    "rgb(178, 223, 208)",
    "rgb(135, 199, 179)",
    "rgb(100, 168, 146)",
    "rgb(70, 139, 117)",
    "rgb(56, 93, 80)",
    "rgb(201, 237, 224)",
    "rgb(176, 229, 213)",
    "rgb(139, 216, 198)",
    "rgb(92, 194, 170)",
    "rgb(34, 167, 141)",
    "rgb(1, 146, 123)",
    "rgb(43, 129, 109)",
    "rgb(200, 237, 222)",
    "rgb(176, 234, 214)",
    "rgb(160, 228, 207)",
    "rgb(132, 222, 198)",
    "rgb(81, 202, 173)",
    "rgb(1, 186, 153)",
    "rgb(1, 155, 124)",
    "rgb(212, 234, 221)",
    "rgb(193, 225, 214)",
    "rgb(176, 216, 204)",
    "rgb(152, 204, 188)",
    "rgb(127, 188, 167)",
    "rgb(90, 159, 133)",
    "rgb(55, 115, 99)",
    "rgb(219, 235, 222)",
    "rgb(200, 222, 206)",
    "rgb(178, 208, 187)",
    "rgb(157, 191, 167)",
    "rgb(130, 165, 137)",
    "rgb(100, 133, 106)",
    "rgb(78, 100, 79)",
    "rgb(196, 217, 205)",
    "rgb(176, 204, 190)",
    "rgb(162, 191, 176)",
    "rgb(139, 172, 153)",
    "rgb(118, 150, 126)",
    "rgb(101, 129, 109)",
    "rgb(87, 113, 96)",
    "rgb(197, 222, 204)",
    "rgb(181, 210, 194)",
    "rgb(157, 194, 179)",
    "rgb(132, 173, 158)",
    "rgb(89, 138, 120)",
    "rgb(65, 117, 102)",
    "rgb(63, 93, 84)",
    "rgb(203, 234, 220)",
    "rgb(189, 228, 216)",
    "rgb(151, 207, 193)",
    "rgb(107, 184, 168)",
    "rgb(87, 164, 147)",
    "rgb(60, 127, 112)",
    "rgb(52, 98, 86)",
    "rgb(206, 241, 229)",
    "rgb(184, 235, 226)",
    "rgb(163, 229, 217)",
    "rgb(122, 214, 203)",
    "rgb(80, 195, 178)",
    "rgb(30, 183, 165)",
    "rgb(1, 146, 130)",
    "rgb(195, 232, 222)",
    "rgb(174, 226, 219)",
    "rgb(136, 214, 210)",
    "rgb(121, 207, 205)",
    "rgb(68, 188, 183)",
    "rgb(1, 167, 162)",
    "rgb(1, 141, 136)",
    "rgb(197, 228, 220)",
    "rgb(179, 222, 215)",
    "rgb(157, 210, 206)",
    "rgb(136, 198, 195)",
    "rgb(105, 178, 174)",
    "rgb(64, 152, 148)",
    "rgb(47, 118, 115)",
    "rgb(199, 223, 219)",
    "rgb(184, 215, 212)",
    "rgb(167, 204, 202)",
    "rgb(144, 189, 187)",
    "rgb(105, 156, 154)",
    "rgb(82, 124, 120)",
    "rgb(62, 89, 92)",
    "rgb(217, 232, 223)",
    "rgb(195, 219, 212)",
    "rgb(172, 201, 193)",
    "rgb(149, 185, 176)",
    "rgb(109, 146, 136)",
    "rgb(86, 118, 109)",
    "rgb(69, 89, 82)",
    "rgb(194, 211, 207)",
    "rgb(187, 206, 201)",
    "rgb(165, 188, 183)",
    "rgb(139, 164, 157)",
    "rgb(117, 143, 137)",
    "rgb(91, 114, 106)",
    "rgb(73, 97, 86)",
    "rgb(205, 218, 208)",
    "rgb(195, 210, 199)",
    "rgb(178, 194, 182)",
    "rgb(157, 173, 159)",
    "rgb(145, 164, 148)",
    "rgb(126, 142, 130)",
    "rgb(97, 111, 100)",
    "rgb(200, 215, 206)",
    "rgb(190, 207, 198)",
    "rgb(171, 191, 181)",
    "rgb(148, 170, 161)",
    "rgb(128, 150, 143)",
    "rgb(114, 137, 128)",
    "rgb(75, 90, 81)",
    "rgb(201, 217, 210)",
    "rgb(184, 205, 200)",
    "rgb(155, 186, 182)",
    "rgb(131, 164, 164)",
    "rgb(112, 144, 143)",
    "rgb(79, 109, 108)",
    "rgb(66, 85, 82)",
    "rgb(219, 230, 227)",
    "rgb(195, 214, 215)",
    "rgb(170, 196, 199)",
    "rgb(152, 179, 184)",
    "rgb(118, 150, 155)",
    "rgb(85, 117, 125)",
    "rgb(71, 91, 94)",
    "rgb(189, 222, 222)",
    "rgb(173, 212, 216)",
    "rgb(137, 190, 201)",
    "rgb(112, 171, 181)",
    "rgb(81, 148, 158)",
    "rgb(58, 123, 134)",
    "rgb(41, 95, 108)",
    "rgb(194, 232, 230)",
    "rgb(171, 225, 224)",
    "rgb(136, 210, 211)",
    "rgb(105, 194, 196)",
    "rgb(59, 170, 170)",
    "rgb(1, 138, 139)",
    "rgb(38, 85, 87)",
    "rgb(183, 227, 226)",
    "rgb(162, 218, 220)",
    "rgb(137, 206, 210)",
    "rgb(124, 200, 204)",
    "rgb(93, 182, 186)",
    "rgb(45, 156, 162)",
    "rgb(36, 120, 124)",
    "rgb(186, 221, 226)",
    "rgb(162, 208, 216)",
    "rgb(150, 201, 211)",
    "rgb(135, 191, 204)",
    "rgb(114, 175, 188)",
    "rgb(86, 153, 170)",
    "rgb(52, 104, 124)",
    "rgb(184, 224, 227)",
    "rgb(166, 216, 221)",
    "rgb(133, 198, 207)",
    "rgb(88, 172, 184)",
    "rgb(51, 147, 162)",
    "rgb(45, 132, 147)",
    "rgb(35, 106, 120)",
    "rgb(159, 218, 227)",
    "rgb(139, 209, 220)",
    "rgb(108, 193, 207)",
    "rgb(70, 174, 191)",
    "rgb(5, 148, 168)",
    "rgb(1, 131, 154)",
    "rgb(61, 109, 123)",
    "rgb(201, 231, 235)",
    "rgb(184, 224, 230)",
    "rgb(161, 215, 227)",
    "rgb(119, 195, 216)",
    "rgb(85, 178, 202)",
    "rgb(32, 161, 194)",
    "rgb(1, 118, 149)",
    "rgb(193, 224, 232)",
    "rgb(172, 212, 227)",
    "rgb(132, 185, 209)",
    "rgb(107, 165, 191)",
    "rgb(84, 149, 181)",
    "rgb(59, 111, 141)",
    "rgb(53, 89, 109)",
    "rgb(181, 220, 235)",
    "rgb(170, 213, 232)",
    "rgb(156, 207, 230)",
    "rgb(126, 189, 220)",
    "rgb(95, 172, 210)",
    "rgb(67, 153, 197)",
    "rgb(37, 117, 164)",
    "rgb(184, 222, 236)",
    "rgb(165, 213, 237)",
    "rgb(149, 205, 232)",
    "rgb(124, 190, 226)",
    "rgb(110, 181, 221)",
    "rgb(64, 158, 210)",
    "rgb(20, 106, 168)",
    "rgb(205, 228, 236)",
    "rgb(186, 218, 232)",
    "rgb(175, 212, 230)",
    "rgb(152, 196, 224)",
    "rgb(108, 164, 209)",
    "rgb(62, 117, 173)",
    "rgb(48, 87, 137)",
    "rgb(184, 213, 227)",
    "rgb(166, 201, 222)",
    "rgb(147, 187, 213)",
    "rgb(122, 168, 198)",
    "rgb(95, 144, 183)",
    "rgb(65, 115, 157)",
    "rgb(54, 85, 116)",
    "rgb(202, 222, 230)",
    "rgb(194, 216, 229)",
    "rgb(162, 192, 214)",
    "rgb(130, 166, 193)",
    "rgb(108, 142, 180)",
    "rgb(58, 106, 153)",
    "rgb(52, 82, 132)",
    "rgb(216, 230, 236)",
    "rgb(193, 216, 233)",
    "rgb(164, 194, 228)",
    "rgb(142, 174, 218)",
    "rgb(111, 149, 205)",
    "rgb(92, 127, 184)",
    "rgb(66, 85, 141)",
    "rgb(200, 214, 229)",
    "rgb(187, 204, 224)",
    "rgb(158, 179, 209)",
    "rgb(136, 159, 192)",
    "rgb(107, 131, 169)",
    "rgb(92, 110, 147)",
    "rgb(66, 75, 99)",
    "rgb(198, 212, 224)",
    "rgb(181, 198, 216)",
    "rgb(166, 184, 206)",
    "rgb(148, 167, 191)",
    "rgb(119, 134, 162)",
    "rgb(93, 107, 134)",
    "rgb(71, 74, 87)",
    "rgb(196, 217, 226)",
    "rgb(187, 210, 221)",
    "rgb(174, 199, 213)",
    "rgb(155, 181, 200)",
    "rgb(134, 161, 183)",
    "rgb(108, 138, 164)",
    "rgb(76, 91, 114)",
    "rgb(235, 241, 234)",
    "rgb(218, 232, 224)",
    "rgb(212, 231, 222)",
    "rgb(239, 243, 236)",
    "rgb(228, 239, 233)",
    "rgb(222, 235, 229)",
    "rgb(215, 232, 227)",
    "rgb(217, 236, 226)",
    "rgb(218, 238, 226)",
    "rgb(213, 236, 219)",
    "rgb(235, 240, 224)",
    "rgb(232, 238, 218)",
    "rgb(228, 237, 218)",
    "rgb(226, 236, 214)",
    "rgb(234, 233, 225)",
    "rgb(228, 227, 219)",
    "rgb(225, 224, 216)",
    "rgb(222, 218, 207)",
    "rgb(212, 207, 197)",
    "rgb(205, 201, 191)",
    "rgb(196, 190, 178)",
    "rgb(230, 231, 221)",
    "rgb(222, 226, 217)",
    "rgb(213, 217, 211)",
    "rgb(229, 236, 229)",
    "rgb(219, 229, 227)",
    "rgb(212, 223, 221)",
    "rgb(213, 222, 221)",
    "rgb(241, 242, 235)",
    "rgb(230, 232, 229)",
    "rgb(221, 224, 223)",
    "rgb(237, 239, 235)",
    "rgb(235, 237, 233)",
    "rgb(226, 231, 230)",
    "rgb(218, 225, 226)",
    "rgb(243, 240, 233)",
    "rgb(241, 236, 229)",
    "rgb(239, 228, 223)",
    "rgb(246, 243, 238)",
    "rgb(245, 240, 235)",
    "rgb(242, 236, 233)",
    "rgb(234, 232, 233)",
    "rgb(249, 235, 228)",
    "rgb(248, 233, 227)",
    "rgb(246, 229, 224)",
    "rgb(249, 234, 225)",
    "rgb(249, 230, 222)",
    "rgb(249, 222, 217)",
    "rgb(250, 219, 212)",
    "rgb(247, 241, 232)",
    "rgb(247, 237, 224)",
    "rgb(249, 232, 219)",
    "rgb(248, 234, 221)",
    "rgb(246, 227, 214)",
    "rgb(244, 223, 203)",
    "rgb(240, 217, 199)",
    "rgb(249, 241, 221)",
    "rgb(250, 234, 210)",
    "rgb(248, 226, 192)",
    "rgb(248, 236, 219)",
    "rgb(248, 232, 213)",
    "rgb(246, 228, 205)",
    "rgb(246, 225, 201)",
    "rgb(247, 241, 226)",
    "rgb(248, 240, 221)",
    "rgb(245, 235, 214)",
    "rgb(244, 231, 212)",
    "rgb(246, 235, 215)",
    "rgb(243, 230, 212)",
    "rgb(241, 225, 202)",
    "rgb(248, 239, 220)",
    "rgb(243, 236, 219)",
    "rgb(247, 235, 211)",
    "rgb(250, 236, 211)",
    "rgb(243, 232, 208)",
    "rgb(247, 228, 196)",
    "rgb(243, 223, 189)",
    "rgb(246, 239, 217)",
    "rgb(244, 235, 209)",
    "rgb(242, 229, 197)",
    "rgb(248, 237, 212)",
    "rgb(247, 233, 202)",
    "rgb(244, 230, 196)",
    "rgb(245, 228, 191)",
    "rgb(243, 240, 224)",
    "rgb(237, 234, 217)",
    "rgb(234, 230, 209)",
    "rgb(247, 240, 215)",
    "rgb(246, 238, 206)",
    "rgb(246, 237, 199)",
    "rgb(245, 234, 193)",
    "rgb(247, 244, 222)",
    "rgb(245, 242, 217)",
    "rgb(244, 239, 209)",
    "rgb(239, 237, 220)",
    "rgb(235, 235, 217)",
    "rgb(230, 230, 211)",
    "rgb(231, 229, 208)",
    "rgb(238, 233, 214)",
    "rgb(231, 226, 204)",
    "rgb(227, 220, 195)",
    "rgb(241, 236, 216)",
    "rgb(236, 231, 211)",
    "rgb(235, 229, 206)",
    "rgb(228, 223, 200)",
    "rgb(244, 233, 213)",
    "rgb(239, 232, 214)",
    "rgb(240, 230, 209)",
    "rgb(238, 229, 209)",
    "rgb(232, 223, 203)",
    "rgb(232, 220, 196)",
    "rgb(227, 213, 190)",
    "rgb(231, 225, 208)",
    "rgb(228, 221, 201)",
    "rgb(220, 211, 189)",
    "rgb(235, 225, 201)",
    "rgb(230, 216, 186)",
    "rgb(227, 211, 180)",
    "rgb(219, 202, 172)",
    "rgb(234, 231, 220)",
    "rgb(232, 229, 218)",
    "rgb(228, 224, 211)",
    "rgb(230, 223, 207)",
    "rgb(225, 217, 199)",
    "rgb(218, 208, 188)",
    "rgb(216, 206, 184)",
    "rgb(243, 242, 231)",
    "rgb(237, 235, 225)",
    "rgb(233, 230, 217)",
    "rgb(236, 231, 216)",
    "rgb(227, 222, 209)",
    "rgb(218, 212, 197)",
    "rgb(204, 199, 185)",
    "rgb(230, 225, 209)",
    "rgb(220, 216, 198)",
    "rgb(203, 197, 177)",
    "rgb(176, 166, 144)",
    "rgb(158, 146, 126)",
    "rgb(134, 123, 105)",
    "rgb(121, 111, 98)",
    "rgb(224, 220, 206)",
    "rgb(216, 207, 192)",
    "rgb(206, 197, 182)",
    "rgb(197, 187, 171)",
    "rgb(174, 163, 145)",
    "rgb(154, 140, 118)",
    "rgb(133, 116, 95)",
    "rgb(223, 212, 199)",
    "rgb(208, 197, 184)",
    "rgb(203, 190, 176)",
    "rgb(184, 170, 157)",
    "rgb(159, 141, 125)",
    "rgb(134, 117, 103)",
    "rgb(124, 109, 94)",
    "rgb(212, 202, 190)",
    "rgb(202, 191, 176)",
    "rgb(184, 171, 155)",
    "rgb(160, 143, 125)",
    "rgb(133, 118, 99)",
    "rgb(112, 98, 82)",
    "rgb(102, 90, 75)",
    "rgb(227, 217, 208)",
    "rgb(221, 212, 203)",
    "rgb(211, 201, 190)",
    "rgb(196, 185, 175)",
    "rgb(170, 155, 142)",
    "rgb(151, 136, 120)",
    "rgb(129, 110, 97)",
    "rgb(233, 221, 210)",
    "rgb(212, 197, 187)",
    "rgb(205, 186, 174)",
    "rgb(181, 157, 142)",
    "rgb(152, 126, 109)",
    "rgb(141, 110, 95)",
    "rgb(127, 100, 86)",
    "rgb(232, 222, 208)",
    "rgb(223, 209, 193)",
    "rgb(203, 186, 169)",
    "rgb(181, 160, 140)",
    "rgb(158, 136, 117)",
    "rgb(137, 116, 98)",
    "rgb(132, 112, 94)",
    "rgb(230, 220, 207)",
    "rgb(224, 211, 197)",
    "rgb(210, 193, 176)",
    "rgb(185, 162, 141)",
    "rgb(157, 129, 110)",
    "rgb(144, 119, 99)",
    "rgb(120, 95, 76)",
    "rgb(227, 213, 195)",
    "rgb(221, 207, 188)",
    "rgb(208, 189, 165)",
    "rgb(189, 167, 141)",
    "rgb(166, 142, 115)",
    "rgb(139, 116, 92)",
    "rgb(131, 109, 85)",
    "rgb(226, 215, 194)",
    "rgb(221, 205, 180)",
    "rgb(208, 187, 157)",
    "rgb(189, 165, 127)",
    "rgb(170, 143, 106)",
    "rgb(154, 125, 88)",
    "rgb(131, 105, 74)",
    "rgb(232, 218, 191)",
    "rgb(224, 207, 175)",
    "rgb(212, 193, 158)",
    "rgb(194, 168, 126)",
    "rgb(168, 137, 92)",
    "rgb(142, 111, 68)",
    "rgb(134, 105, 71)",
    "rgb(233, 221, 201)",
    "rgb(226, 208, 182)",
    "rgb(206, 186, 160)",
    "rgb(185, 162, 132)",
    "rgb(167, 141, 109)",
    "rgb(153, 125, 94)",
    "rgb(140, 116, 86)",
    "rgb(231, 215, 189)",
    "rgb(224, 207, 180)",
    "rgb(212, 191, 159)",
    "rgb(195, 167, 129)",
    "rgb(183, 152, 109)",
    "rgb(171, 134, 92)",
    "rgb(153, 115, 73)",
    "rgb(239, 229, 209)",
    "rgb(234, 222, 198)",
    "rgb(227, 207, 176)",
    "rgb(219, 197, 164)",
    "rgb(202, 173, 135)",
    "rgb(194, 158, 116)",
    "rgb(168, 128, 88)",
    "rgb(235, 219, 195)",
    "rgb(232, 217, 191)",
    "rgb(222, 202, 173)",
    "rgb(202, 180, 149)",
    "rgb(193, 168, 136)",
    "rgb(177, 153, 123)",
    "rgb(161, 133, 98)",
    "rgb(230, 214, 196)",
    "rgb(224, 206, 188)",
    "rgb(216, 195, 174)",
    "rgb(202, 176, 153)",
    "rgb(181, 151, 123)",
    "rgb(150, 117, 90)",
    "rgb(143, 113, 87)",
    "rgb(242, 227, 207)",
    "rgb(235, 215, 190)",
    "rgb(230, 203, 173)",
    "rgb(212, 179, 143)",
    "rgb(196, 156, 117)",
    "rgb(175, 130, 88)",
    "rgb(170, 124, 85)",
    "rgb(235, 224, 202)",
    "rgb(233, 219, 194)",
    "rgb(219, 203, 173)",
    "rgb(202, 175, 133)",
    "rgb(195, 166, 122)",
    "rgb(180, 151, 103)",
    "rgb(169, 136, 92)",
    "rgb(235, 213, 177)",
    "rgb(228, 200, 158)",
    "rgb(214, 180, 136)",
    "rgb(206, 167, 117)",
    "rgb(192, 148, 101)",
    "rgb(185, 142, 97)",
    "rgb(173, 131, 86)",
    "rgb(235, 215, 183)",
    "rgb(235, 211, 178)",
    "rgb(231, 201, 164)",
    "rgb(213, 180, 134)",
    "rgb(203, 165, 115)",
    "rgb(192, 152, 102)",
    "rgb(165, 125, 80)",
    "rgb(239, 221, 191)",
    "rgb(233, 209, 175)",
    "rgb(219, 190, 153)",
    "rgb(203, 168, 123)",
    "rgb(184, 146, 100)",
    "rgb(156, 114, 74)",
    "rgb(144, 102, 66)",
    "rgb(224, 205, 183)",
    "rgb(219, 198, 173)",
    "rgb(201, 173, 143)",
    "rgb(186, 154, 121)",
    "rgb(152, 118, 86)",
    "rgb(147, 115, 85)",
    "rgb(128, 103, 79)",
    "rgb(217, 197, 172)",
    "rgb(201, 172, 140)",
    "rgb(198, 165, 134)",
    "rgb(183, 145, 108)",
    "rgb(164, 122, 91)",
    "rgb(150, 111, 87)",
    "rgb(131, 95, 71)",
    "rgb(243, 228, 209)",
    "rgb(235, 212, 188)",
    "rgb(228, 196, 167)",
    "rgb(211, 172, 137)",
    "rgb(187, 142, 102)",
    "rgb(157, 111, 74)",
    "rgb(144, 104, 73)",
    "rgb(236, 216, 192)",
    "rgb(229, 205, 178)",
    "rgb(227, 194, 157)",
    "rgb(214, 175, 132)",
    "rgb(205, 152, 101)",
    "rgb(191, 136, 90)",
    "rgb(183, 131, 84)",
    "rgb(240, 224, 205)",
    "rgb(234, 213, 193)",
    "rgb(225, 196, 174)",
    "rgb(218, 189, 166)",
    "rgb(206, 167, 137)",
    "rgb(197, 151, 119)",
    "rgb(169, 121, 88)",
    "rgb(241, 227, 211)",
    "rgb(233, 216, 199)",
    "rgb(225, 201, 183)",
    "rgb(209, 178, 156)",
    "rgb(182, 145, 120)",
    "rgb(165, 124, 101)",
    "rgb(154, 117, 94)",
    "rgb(238, 220, 206)",
    "rgb(232, 210, 195)",
    "rgb(221, 193, 176)",
    "rgb(217, 187, 166)",
    "rgb(197, 163, 138)",
    "rgb(190, 146, 117)",
    "rgb(157, 113, 90)",
    "rgb(241, 227, 213)",
    "rgb(236, 219, 205)",
    "rgb(227, 201, 187)",
    "rgb(215, 180, 164)",
    "rgb(209, 175, 160)",
    "rgb(189, 146, 128)",
    "rgb(157, 115, 96)",
    "rgb(231, 208, 198)",
    "rgb(225, 197, 185)",
    "rgb(208, 175, 161)",
    "rgb(192, 152, 138)",
    "rgb(186, 142, 126)",
    "rgb(167, 120, 105)",
    "rgb(142, 94, 81)",
    "rgb(243, 228, 216)",
    "rgb(241, 220, 211)",
    "rgb(230, 201, 192)",
    "rgb(218, 180, 167)",
    "rgb(203, 157, 143)",
    "rgb(188, 137, 120)",
    "rgb(153, 90, 74)",
    "rgb(243, 218, 205)",
    "rgb(233, 198, 185)",
    "rgb(211, 161, 143)",
    "rgb(194, 137, 115)",
    "rgb(183, 121, 98)",
    "rgb(159, 99, 78)",
    "rgb(145, 92, 72)",
    "rgb(243, 201, 182)",
    "rgb(229, 182, 167)",
    "rgb(213, 156, 139)",
    "rgb(194, 122, 107)",
    "rgb(180, 106, 88)",
    "rgb(166, 90, 79)",
    "rgb(143, 81, 74)",
    "rgb(227, 194, 172)",
    "rgb(221, 184, 160)",
    "rgb(208, 167, 142)",
    "rgb(189, 140, 111)",
    "rgb(163, 111, 88)",
    "rgb(156, 104, 83)",
    "rgb(136, 95, 77)",
    "rgb(247, 229, 215)",
    "rgb(242, 218, 199)",
    "rgb(233, 199, 177)",
    "rgb(223, 182, 158)",
    "rgb(207, 157, 127)",
    "rgb(183, 126, 95)",
    "rgb(157, 103, 76)",
    "rgb(219, 185, 162)",
    "rgb(203, 163, 135)",
    "rgb(186, 136, 103)",
    "rgb(178, 126, 97)",
    "rgb(161, 115, 90)",
    "rgb(143, 102, 83)",
    "rgb(131, 91, 74)",
    "rgb(217, 190, 174)",
    "rgb(196, 158, 136)",
    "rgb(184, 141, 118)",
    "rgb(168, 122, 101)",
    "rgb(135, 97, 80)",
    "rgb(125, 92, 79)",
    "rgb(105, 80, 71)",
    "rgb(206, 182, 171)",
    "rgb(182, 153, 139)",
    "rgb(154, 122, 105)",
    "rgb(143, 111, 96)",
    "rgb(115, 88, 73)",
    "rgb(101, 82, 70)",
    "rgb(96, 81, 72)",
    "rgb(233, 218, 213)",
    "rgb(225, 207, 202)",
    "rgb(208, 184, 178)",
    "rgb(192, 165, 161)",
    "rgb(166, 136, 134)",
    "rgb(135, 106, 100)",
    "rgb(107, 85, 77)",
    "rgb(235, 226, 223)",
    "rgb(224, 210, 209)",
    "rgb(206, 186, 188)",
    "rgb(190, 168, 169)",
    "rgb(163, 138, 140)",
    "rgb(128, 105, 105)",
    "rgb(96, 79, 76)",
    "rgb(226, 199, 198)",
    "rgb(217, 181, 182)",
    "rgb(201, 153, 151)",
    "rgb(155, 110, 108)",
    "rgb(141, 90, 87)",
    "rgb(120, 78, 75)",
    "rgb(100, 70, 68)",
    "rgb(233, 216, 214)",
    "rgb(225, 203, 204)",
    "rgb(211, 181, 180)",
    "rgb(191, 154, 155)",
    "rgb(154, 111, 112)",
    "rgb(134, 90, 94)",
    "rgb(110, 67, 68)",
    "rgb(247, 224, 225)",
    "rgb(243, 205, 208)",
    "rgb(230, 183, 192)",
    "rgb(217, 160, 169)",
    "rgb(199, 135, 146)",
    "rgb(175, 109, 118)",
    "rgb(146, 78, 79)",
    "rgb(245, 216, 214)",
    "rgb(236, 200, 202)",
    "rgb(229, 179, 182)",
    "rgb(211, 155, 157)",
    "rgb(200, 135, 141)",
    "rgb(178, 116, 119)",
    "rgb(145, 85, 86)",
    "rgb(244, 212, 210)",
    "rgb(234, 179, 181)",
    "rgb(224, 152, 157)",
    "rgb(222, 145, 146)",
    "rgb(196, 108, 111)",
    "rgb(172, 96, 95)",
    "rgb(156, 76, 74)",
    "rgb(243, 216, 209)",
    "rgb(240, 201, 198)",
    "rgb(229, 179, 175)",
    "rgb(218, 155, 149)",
    "rgb(189, 117, 108)",
    "rgb(175, 104, 95)",
    "rgb(138, 81, 79)",
    "rgb(244, 189, 187)",
    "rgb(231, 155, 150)",
    "rgb(205, 117, 106)",
    "rgb(183, 98, 87)",
    "rgb(167, 77, 68)",
    "rgb(153, 73, 66)",
    "rgb(127, 75, 71)",
    "rgb(255, 194, 192)",
    "rgb(240, 140, 133)",
    "rgb(231, 112, 105)",
    "rgb(211, 87, 75)",
    "rgb(194, 77, 70)",
    "rgb(185, 74, 70)",
    "rgb(169, 68, 67)",
    "rgb(250, 199, 205)",
    "rgb(248, 181, 191)",
    "rgb(232, 132, 142)",
    "rgb(217, 93, 103)",
    "rgb(204, 72, 71)",
    "rgb(190, 59, 67)",
    "rgb(166, 65, 73)",
    "rgb(246, 221, 218)",
    "rgb(247, 194, 199)",
    "rgb(239, 153, 159)",
    "rgb(232, 112, 118)",
    "rgb(195, 77, 78)",
    "rgb(177, 63, 68)",
    "rgb(161, 62, 66)",
    "rgb(251, 199, 210)",
    "rgb(251, 183, 198)",
    "rgb(248, 163, 181)",
    "rgb(236, 133, 151)",
    "rgb(222, 104, 122)",
    "rgb(188, 67, 85)",
    "rgb(166, 66, 78)",
    "rgb(248, 218, 216)",
    "rgb(250, 209, 210)",
    "rgb(246, 178, 188)",
    "rgb(240, 149, 158)",
    "rgb(233, 103, 117)",
    "rgb(189, 70, 81)",
    "rgb(177, 67, 84)",
    "rgb(247, 215, 215)",
    "rgb(241, 181, 194)",
    "rgb(230, 155, 169)",
    "rgb(214, 121, 140)",
    "rgb(186, 90, 107)",
    "rgb(174, 55, 79)",
    "rgb(151, 64, 81)",
    "rgb(246, 198, 221)",
    "rgb(233, 153, 192)",
    "rgb(222, 123, 166)",
    "rgb(202, 83, 128)",
    "rgb(179, 71, 105)",
    "rgb(176, 65, 92)",
    "rgb(158, 61, 84)",
    "rgb(244, 215, 219)",
    "rgb(244, 210, 220)",
    "rgb(228, 176, 198)",
    "rgb(200, 123, 155)",
    "rgb(159, 88, 117)",
    "rgb(126, 73, 91)",
    "rgb(104, 75, 79)",
    "rgb(243, 221, 223)",
    "rgb(234, 206, 215)",
    "rgb(222, 179, 199)",
    "rgb(202, 152, 176)",
    "rgb(187, 119, 154)",
    "rgb(147, 79, 107)",
    "rgb(109, 70, 82)",
    "rgb(239, 225, 227)",
    "rgb(239, 214, 224)",
    "rgb(227, 197, 214)",
    "rgb(217, 179, 203)",
    "rgb(190, 145, 175)",
    "rgb(144, 101, 132)",
    "rgb(118, 82, 115)",
    "rgb(239, 227, 223)",
    "rgb(229, 212, 215)",
    "rgb(215, 192, 207)",
    "rgb(205, 175, 198)",
    "rgb(188, 150, 175)",
    "rgb(142, 104, 131)",
    "rgb(110, 75, 98)",
    "rgb(226, 213, 222)",
    "rgb(213, 200, 215)",
    "rgb(206, 192, 210)",
    "rgb(171, 153, 174)",
    "rgb(155, 132, 161)",
    "rgb(126, 103, 134)",
    "rgb(92, 68, 94)",
    "rgb(228, 222, 222)",
    "rgb(221, 206, 222)",
    "rgb(204, 184, 209)",
    "rgb(181, 153, 190)",
    "rgb(160, 125, 166)",
    "rgb(119, 90, 128)",
    "rgb(85, 70, 87)",
    "rgb(228, 221, 233)",
    "rgb(213, 200, 227)",
    "rgb(190, 174, 214)",
    "rgb(172, 152, 201)",
    "rgb(148, 122, 177)",
    "rgb(109, 90, 142)",
    "rgb(100, 81, 132)",
    "rgb(225, 226, 233)",
    "rgb(212, 210, 225)",
    "rgb(200, 196, 218)",
    "rgb(179, 171, 201)",
    "rgb(157, 149, 188)",
    "rgb(138, 127, 171)",
    "rgb(95, 84, 133)",
    "rgb(234, 236, 231)",
    "rgb(218, 220, 227)",
    "rgb(211, 211, 221)",
    "rgb(196, 195, 209)",
    "rgb(167, 167, 190)",
    "rgb(131, 128, 147)",
    "rgb(82, 77, 91)",
    "rgb(219, 222, 235)",
    "rgb(214, 219, 231)",
    "rgb(201, 209, 228)",
    "rgb(181, 190, 218)",
    "rgb(147, 156, 195)",
    "rgb(129, 134, 181)",
    "rgb(84, 89, 139)",
    "rgb(215, 217, 224)",
    "rgb(198, 201, 213)",
    "rgb(173, 180, 203)",
    "rgb(155, 162, 186)",
    "rgb(125, 130, 158)",
    "rgb(106, 110, 135)",
    "rgb(81, 77, 92)",
    "rgb(209, 214, 228)",
    "rgb(198, 205, 224)",
    "rgb(190, 198, 221)",
    "rgb(168, 178, 205)",
    "rgb(148, 161, 190)",
    "rgb(117, 126, 147)",
    "rgb(93, 99, 117)",
    "rgb(223, 227, 228)",
    "rgb(202, 209, 217)",
    "rgb(180, 186, 200)",
    "rgb(161, 167, 183)",
    "rgb(133, 138, 155)",
    "rgb(111, 114, 131)",
    "rgb(74, 73, 77)",
    "rgb(229, 222, 223)",
    "rgb(215, 207, 210)",
    "rgb(197, 189, 193)",
    "rgb(181, 170, 176)",
    "rgb(164, 149, 154)",
    "rgb(147, 130, 136)",
    "rgb(119, 96, 98)",
    "rgb(230, 225, 222)",
    "rgb(212, 208, 209)",
    "rgb(194, 186, 190)",
    "rgb(176, 169, 175)",
    "rgb(153, 140, 145)",
    "rgb(123, 112, 117)",
    "rgb(104, 93, 96)",
    "rgb(230, 225, 220)",
    "rgb(221, 218, 214)",
    "rgb(203, 203, 201)",
    "rgb(180, 178, 177)",
    "rgb(161, 159, 158)",
    "rgb(122, 115, 114)",
    "rgb(97, 85, 80)",
    "rgb(220, 217, 207)",
    "rgb(208, 205, 197)",
    "rgb(194, 192, 187)",
    "rgb(181, 179, 175)",
    "rgb(163, 158, 151)",
    "rgb(140, 133, 125)",
    "rgb(115, 107, 99)",
    "rgb(218, 217, 212)",
    "rgb(200, 200, 195)",
    "rgb(183, 181, 173)",
    "rgb(174, 172, 163)",
    "rgb(154, 150, 141)",
    "rgb(142, 137, 123)",
    "rgb(108, 102, 92)",
    "rgb(224, 226, 220)",
    "rgb(213, 216, 211)",
    "rgb(204, 208, 202)",
    "rgb(188, 191, 185)",
    "rgb(165, 168, 159)",
    "rgb(138, 141, 132)",
    "rgb(87, 89, 82)",
    "rgb(201, 199, 186)",
    "rgb(194, 192, 178)",
    "rgb(175, 171, 155)",
    "rgb(150, 146, 128)",
    "rgb(124, 119, 102)",
    "rgb(111, 106, 89)",
    "rgb(94, 90, 77)",
    "rgb(232, 232, 222)",
    "rgb(222, 221, 206)",
    "rgb(200, 201, 184)",
    "rgb(183, 185, 166)",
    "rgb(155, 157, 136)",
    "rgb(136, 137, 115)",
    "rgb(99, 101, 82)",
    "rgb(228, 227, 214)",
    "rgb(213, 212, 196)",
    "rgb(197, 195, 177)",
    "rgb(176, 172, 148)",
    "rgb(164, 160, 136)",
    "rgb(136, 133, 108)",
    "rgb(106, 104, 84)",
    "rgb(226, 224, 208)",
    "rgb(219, 218, 202)",
    "rgb(211, 210, 192)",
    "rgb(198, 196, 175)",
    "rgb(175, 170, 144)",
    "rgb(154, 147, 118)",
    "rgb(130, 122, 95)",
    "rgb(238, 236, 222)",
    "rgb(230, 228, 213)",
    "rgb(223, 220, 200)",
    "rgb(206, 203, 179)",
    "rgb(186, 180, 151)",
    "rgb(163, 151, 118)",
    "rgb(136, 125, 95)",
    "rgb(227, 223, 208)",
    "rgb(219, 214, 199)",
    "rgb(206, 200, 180)",
    "rgb(185, 175, 150)",
    "rgb(173, 162, 131)",
    "rgb(143, 130, 100)",
    "rgb(112, 103, 79)",
    "rgb(225, 223, 210)",
    "rgb(220, 217, 202)",
    "rgb(207, 204, 187)",
    "rgb(193, 188, 170)",
    "rgb(169, 162, 138)",
    "rgb(144, 135, 108)",
    "rgb(126, 116, 94)",
    "rgb(209, 206, 195)",
    "rgb(202, 198, 185)",
    "rgb(187, 182, 168)",
    "rgb(161, 155, 138)",
    "rgb(146, 139, 121)",
    "rgb(128, 120, 103)",
    "rgb(109, 101, 84)",
    "rgb(205, 200, 190)",
    "rgb(191, 185, 175)",
    "rgb(183, 176, 164)",
    "rgb(166, 155, 142)",
    "rgb(140, 131, 117)",
    "rgb(125, 118, 104)",
    "rgb(86, 82, 75)",
    "rgb(228, 225, 216)",
    "rgb(219, 215, 205)",
    "rgb(198, 194, 185)",
    "rgb(185, 181, 173)",
    "rgb(167, 160, 148)",
    "rgb(145, 137, 121)",
    "rgb(115, 105, 90)",
    "rgb(222, 222, 212)",
    "rgb(208, 209, 198)",
    "rgb(195, 196, 186)",
    "rgb(177, 177, 166)",
    "rgb(155, 155, 143)",
    "rgb(140, 139, 124)",
    "rgb(106, 104, 88)",
    "rgb(214, 220, 211)",
    "rgb(200, 208, 201)",
    "rgb(180, 191, 186)",
    "rgb(164, 177, 175)",
    "rgb(140, 149, 145)",
    "rgb(123, 133, 128)",
    "rgb(98, 106, 101)",
    "rgb(208, 212, 201)",
    "rgb(192, 199, 188)",
    "rgb(177, 186, 179)",
    "rgb(168, 180, 171)",
    "rgb(163, 174, 166)",
    "rgb(140, 152, 143)",
    "rgb(101, 108, 98)",
    "rgb(212, 218, 211)",
    "rgb(202, 208, 202)",
    "rgb(177, 186, 180)",
    "rgb(158, 169, 162)",
    "rgb(130, 138, 130)",
    "rgb(107, 114, 107)",
    "rgb(76, 79, 75)",
    "rgb(215, 222, 214)",
    "rgb(202, 212, 209)",
    "rgb(186, 198, 196)",
    "rgb(168, 179, 177)",
    "rgb(144, 154, 154)",
    "rgb(121, 130, 130)",
    "rgb(101, 108, 105)",
    "rgb(225, 227, 221)",
    "rgb(207, 211, 207)",
    "rgb(181, 188, 189)",
    "rgb(161, 169, 169)",
    "rgb(132, 138, 139)",
    "rgb(109, 114, 114)",
    "rgb(76, 79, 79)",
    "rgb(201, 206, 206)",
    "rgb(193, 199, 198)",
    "rgb(174, 180, 180)",
    "rgb(155, 160, 159)",
    "rgb(137, 142, 144)",
    "rgb(107, 112, 113)",
    "rgb(69, 71, 72)",
    "rgb(208, 213, 210)",
    "rgb(186, 192, 191)",
    "rgb(159, 166, 166)",
    "rgb(128, 133, 136)",
    "rgb(106, 110, 115)",
    "rgb(85, 89, 93)",
    "rgb(77, 80, 83)",
    "rgb(217, 218, 217)",
    "rgb(199, 204, 205)",
    "rgb(177, 181, 184)",
    "rgb(155, 160, 163)",
    "rgb(128, 132, 135)",
    "rgb(99, 102, 105)",
    "rgb(76, 78, 80)",
    "rgb(219, 225, 228)",
    "rgb(201, 211, 215)",
    "rgb(178, 192, 200)",
    "rgb(159, 174, 184)",
    "rgb(130, 145, 156)",
    "rgb(104, 116, 125)",
    "rgb(79, 84, 88)",
    "rgb(209, 217, 218)",
    "rgb(193, 203, 206)",
    "rgb(173, 184, 193)",
    "rgb(152, 163, 175)",
    "rgb(118, 132, 146)",
    "rgb(96, 103, 109)",
    "rgb(71, 72, 73)",
    "rgb(213, 223, 222)",
    "rgb(196, 209, 211)",
    "rgb(163, 181, 187)",
    "rgb(135, 153, 159)",
    "rgb(103, 122, 128)",
    "rgb(97, 113, 120)",
    "rgb(74, 79, 83)",
    "rgb(201, 217, 218)",
    "rgb(190, 210, 213)",
    "rgb(178, 200, 204)",
    "rgb(162, 187, 193)",
    "rgb(133, 161, 172)",
    "rgb(111, 136, 146)",
    "rgb(95, 117, 129)",
    "rgb(219, 228, 227)",
    "rgb(192, 209, 213)",
    "rgb(156, 178, 188)",
    "rgb(125, 148, 159)",
    "rgb(99, 121, 134)",
    "rgb(69, 90, 99)",
    "rgb(68, 82, 86)",
    "rgb(201, 223, 227)",
    "rgb(186, 212, 219)",
    "rgb(175, 204, 213)",
    "rgb(150, 186, 199)",
    "rgb(119, 159, 177)",
    "rgb(98, 135, 152)",
    "rgb(79, 101, 112)",
    "rgb(213, 227, 229)",
    "rgb(196, 216, 222)",
    "rgb(165, 194, 206)",
    "rgb(144, 176, 192)",
    "rgb(113, 147, 164)",
    "rgb(84, 115, 133)",
    "rgb(66, 87, 100)",
    "rgb(204, 221, 224)",
    "rgb(177, 202, 209)",
    "rgb(148, 178, 189)",
    "rgb(128, 158, 173)",
    "rgb(108, 137, 150)",
    "rgb(104, 130, 144)",
    "rgb(77, 100, 111)",
    "rgb(204, 222, 227)",
    "rgb(189, 213, 222)",
    "rgb(161, 191, 207)",
    "rgb(130, 163, 183)",
    "rgb(100, 136, 160)",
    "rgb(79, 116, 141)",
    "rgb(64, 83, 103)",
    "rgb(253, 227, 231)",
    "rgb(255, 206, 217)",
    "rgb(254, 173, 190)",
    "rgb(246, 128, 149)",
    "rgb(225, 77, 92)",
    "rgb(212, 59, 66)",
    "rgb(202, 47, 47)",
    "rgb(255, 227, 232)",
    "rgb(255, 206, 217)",
    "rgb(255, 173, 190)",
    "rgb(246, 127, 147)",
    "rgb(226, 76, 91)",
    "rgb(214, 58, 64)",
    "rgb(203, 45, 45)",
    "rgb(254, 232, 233)",
    "rgb(255, 212, 217)",
    "rgb(255, 180, 190)",
    "rgb(249, 136, 146)",
    "rgb(231, 85, 89)",
    "rgb(218, 63, 61)",
    "rgb(208, 50, 44)",
    "rgb(254, 227, 231)",
    "rgb(255, 206, 215)",
    "rgb(250, 172, 187)",
    "rgb(238, 127, 143)",
    "rgb(213, 77, 88)",
    "rgb(196, 62, 62)",
    "rgb(182, 52, 45)",
    "rgb(253, 228, 232)",
    "rgb(253, 205, 215)",
    "rgb(246, 173, 189)",
    "rgb(229, 128, 145)",
    "rgb(203, 80, 91)",
    "rgb(178, 65, 65)",
    "rgb(161, 56, 48)",
    "rgb(248, 229, 229)",
    "rgb(241, 206, 210)",
    "rgb(226, 174, 180)",
    "rgb(200, 129, 135)",
    "rgb(157, 83, 82)",
    "rgb(139, 70, 63)",
    "rgb(125, 63, 51)",
    "rgb(251, 225, 225)",
    "rgb(247, 201, 203)",
    "rgb(235, 167, 170)",
    "rgb(212, 121, 121)",
    "rgb(178, 77, 70)",
    "rgb(166, 68, 56)",
    "rgb(158, 62, 46)",
    "rgb(253, 226, 228)",
    "rgb(251, 204, 209)",
    "rgb(243, 171, 180)",
    "rgb(223, 125, 132)",
    "rgb(191, 79, 79)",
    "rgb(175, 66, 57)",
    "rgb(164, 59, 46)",
    "rgb(254, 233, 231)",
    "rgb(255, 215, 214)",
    "rgb(252, 186, 186)",
    "rgb(241, 145, 142)",
    "rgb(216, 96, 87)",
    "rgb(202, 80, 68)",
    "rgb(190, 71, 57)",
    "rgb(254, 232, 229)",
    "rgb(255, 213, 212)",
    "rgb(255, 183, 183)",
    "rgb(249, 139, 136)",
    "rgb(232, 91, 81)",
    "rgb(221, 72, 58)",
    "rgb(212, 60, 44)",
    "rgb(254, 234, 228)",
    "rgb(255, 216, 210)",
    "rgb(255, 186, 180)",
    "rgb(250, 144, 132)",
    "rgb(234, 96, 78)",
    "rgb(224, 77, 56)",
    "rgb(216, 65, 44)",
    "rgb(254, 235, 231)",
    "rgb(255, 218, 213)",
    "rgb(255, 191, 185)",
    "rgb(254, 153, 143)",
    "rgb(241, 101, 81)",
    "rgb(232, 82, 60)",
    "rgb(225, 66, 44)",
    "rgb(254, 236, 230)",
    "rgb(255, 220, 213)",
    "rgb(255, 193, 184)",
    "rgb(255, 154, 138)",
    "rgb(242, 104, 81)",
    "rgb(232, 82, 55)",
    "rgb(225, 67, 40)",
    "rgb(254, 238, 230)",
    "rgb(255, 223, 212)",
    "rgb(255, 198, 182)",
    "rgb(255, 159, 133)",
    "rgb(245, 112, 76)",
    "rgb(235, 90, 52)",
    "rgb(228, 77, 41)",
    "rgb(254, 240, 227)",
    "rgb(255, 226, 208)",
    "rgb(255, 203, 177)",
    "rgb(255, 167, 127)",
    "rgb(248, 122, 71)",
    "rgb(240, 102, 49)",
    "rgb(234, 89, 36)",
    "rgb(253, 243, 226)",
    "rgb(255, 232, 204)",
    "rgb(255, 213, 171)",
    "rgb(255, 182, 120)",
    "rgb(252, 140, 61)",
    "rgb(246, 125, 41)",
    "rgb(241, 113, 27)",
    "rgb(253, 244, 223)",
    "rgb(255, 235, 202)",
    "rgb(255, 217, 167)",
    "rgb(255, 187, 114)",
    "rgb(253, 150, 56)",
    "rgb(248, 134, 36)",
    "rgb(245, 125, 28)",
    "rgb(253, 245, 223)",
    "rgb(255, 237, 200)",
    "rgb(255, 222, 167)",
    "rgb(255, 196, 112)",
    "rgb(255, 162, 53)",
    "rgb(253, 148, 31)",
    "rgb(250, 139, 13)",
    "rgb(252, 247, 222)",
    "rgb(255, 241, 199)",
    "rgb(255, 229, 162)",
    "rgb(255, 208, 108)",
    "rgb(255, 179, 42)",
    "rgb(255, 168, 7)",
    "rgb(255, 160, 1)",
    "rgb(252, 247, 220)",
    "rgb(255, 243, 196)",
    "rgb(255, 233, 160)",
    "rgb(255, 216, 103)",
    "rgb(255, 195, 28)",
    "rgb(255, 184, 1)",
    "rgb(255, 176, 1)",
    "rgb(252, 248, 222)",
    "rgb(255, 244, 197)",
    "rgb(255, 234, 160)",
    "rgb(255, 217, 104)",
    "rgb(255, 196, 31)",
    "rgb(255, 183, 1)",
    "rgb(255, 177, 1)",
    "rgb(252, 248, 220)",
    "rgb(255, 245, 196)",
    "rgb(255, 237, 159)",
    "rgb(255, 223, 101)",
    "rgb(255, 207, 12)",
    "rgb(255, 197, 1)",
    "rgb(255, 190, 1)",
    "rgb(251, 248, 221)",
    "rgb(254, 246, 197)",
    "rgb(255, 242, 160)",
    "rgb(255, 232, 102)",
    "rgb(255, 220, 1)",
    "rgb(255, 215, 1)",
    "rgb(255, 213, 1)",
    "rgb(252, 249, 222)",
    "rgb(253, 246, 197)",
    "rgb(255, 241, 162)",
    "rgb(251, 229, 103)",
    "rgb(249, 215, 11)",
    "rgb(241, 206, 1)",
    "rgb(237, 202, 1)",
    "rgb(251, 249, 225)",
    "rgb(251, 245, 201)",
    "rgb(247, 237, 170)",
    "rgb(237, 221, 114)",
    "rgb(216, 198, 47)",
    "rgb(205, 188, 15)",
    "rgb(194, 181, 1)",
    "rgb(248, 249, 220)",
    "rgb(248, 247, 196)",
    "rgb(241, 241, 160)",
    "rgb(226, 229, 102)",
    "rgb(211, 215, 19)",
    "rgb(196, 208, 1)",
    "rgb(181, 203, 1)",
    "rgb(248, 249, 221)",
    "rgb(244, 246, 198)",
    "rgb(232, 240, 161)",
    "rgb(211, 226, 106)",
    "rgb(190, 210, 33)",
    "rgb(165, 200, 1)",
    "rgb(152, 194, 1)",
    "rgb(246, 247, 220)",
    "rgb(243, 243, 196)",
    "rgb(233, 234, 160)",
    "rgb(214, 217, 106)",
    "rgb(192, 197, 41)",
    "rgb(172, 186, 22)",
    "rgb(154, 177, 10)",
    "rgb(245, 247, 222)",
    "rgb(238, 242, 200)",
    "rgb(222, 230, 164)",
    "rgb(196, 210, 112)",
    "rgb(167, 187, 51)",
    "rgb(137, 171, 40)",
    "rgb(122, 163, 31)",
    "rgb(241, 246, 223)",
    "rgb(229, 239, 201)",
    "rgb(206, 224, 168)",
    "rgb(173, 200, 117)",
    "rgb(124, 167, 65)",
    "rgb(103, 155, 49)",
    "rgb(87, 146, 41)",
    "rgb(237, 248, 225)",
    "rgb(220, 244, 204)",
    "rgb(192, 233, 171)",
    "rgb(152, 213, 120)",
    "rgb(98, 185, 63)",
    "rgb(73, 172, 45)",
    "rgb(52, 162, 35)",
    "rgb(240, 249, 224)",
    "rgb(226, 244, 202)",
    "rgb(204, 235, 168)",
    "rgb(168, 217, 116)",
    "rgb(121, 192, 57)",
    "rgb(99, 181, 37)",
    "rgb(81, 172, 25)",
    "rgb(232, 247, 226)",
    "rgb(214, 243, 207)",
    "rgb(183, 231, 176)",
    "rgb(137, 210, 127)",
    "rgb(79, 179, 70)",
    "rgb(51, 165, 50)",
    "rgb(23, 154, 41)",
    "rgb(228, 247, 230)",
    "rgb(204, 241, 211)",
    "rgb(167, 228, 182)",
    "rgb(115, 205, 137)",
    "rgb(50, 171, 81)",
    "rgb(1, 153, 61)",
    "rgb(1, 139, 50)",
    "rgb(230, 242, 227)",
    "rgb(208, 231, 207)",
    "rgb(175, 211, 177)",
    "rgb(128, 180, 128)",
    "rgb(69, 141, 79)",
    "rgb(48, 126, 64)",
    "rgb(33, 116, 56)",
    "rgb(226, 241, 229)",
    "rgb(201, 228, 211)",
    "rgb(164, 206, 182)",
    "rgb(114, 174, 136)",
    "rgb(53, 132, 85)",
    "rgb(35, 117, 67)",
    "rgb(20, 106, 57)",
    "rgb(227, 246, 234)",
    "rgb(202, 237, 219)",
    "rgb(165, 221, 194)",
    "rgb(118, 193, 154)",
    "rgb(67, 150, 102)",
    "rgb(53, 127, 81)",
    "rgb(48, 112, 71)",
    "rgb(221, 247, 234)",
    "rgb(193, 240, 220)",
    "rgb(149, 226, 195)",
    "rgb(84, 200, 154)",
    "rgb(1, 162, 99)",
    "rgb(1, 136, 75)",
    "rgb(1, 113, 59)",
    "rgb(221, 247, 236)",
    "rgb(192, 238, 223)",
    "rgb(150, 222, 200)",
    "rgb(92, 195, 163)",
    "rgb(11, 152, 110)",
    "rgb(1, 125, 87)",
    "rgb(13, 102, 71)",
    "rgb(217, 247, 237)",
    "rgb(185, 239, 225)",
    "rgb(134, 224, 204)",
    "rgb(54, 199, 169)",
    "rgb(1, 159, 118)",
    "rgb(1, 130, 89)",
    "rgb(1, 99, 67)",
    "rgb(218, 238, 232)",
    "rgb(192, 225, 216)",
    "rgb(147, 199, 188)",
    "rgb(93, 165, 147)",
    "rgb(24, 120, 93)",
    "rgb(11, 102, 73)",
    "rgb(17, 91, 61)",
    "rgb(223, 245, 238)",
    "rgb(195, 233, 225)",
    "rgb(155, 214, 204)",
    "rgb(102, 181, 166)",
    "rgb(53, 130, 112)",
    "rgb(42, 99, 84)",
    "rgb(43, 70, 62)",
    "rgb(217, 246, 237)",
    "rgb(185, 239, 226)",
    "rgb(135, 223, 206)",
    "rgb(62, 199, 172)",
    "rgb(1, 158, 124)",
    "rgb(1, 127, 94)",
    "rgb(1, 97, 72)",
    "rgb(216, 245, 237)",
    "rgb(185, 236, 226)",
    "rgb(138, 221, 206)",
    "rgb(70, 194, 173)",
    "rgb(1, 151, 123)",
    "rgb(1, 117, 94)",
    "rgb(6, 82, 68)",
    "rgb(212, 245, 236)",
    "rgb(180, 238, 226)",
    "rgb(127, 223, 206)",
    "rgb(38, 200, 176)",
    "rgb(1, 160, 127)",
    "rgb(1, 132, 100)",
    "rgb(1, 98, 74)",
    "rgb(213, 245, 238)",
    "rgb(180, 238, 227)",
    "rgb(128, 222, 208)",
    "rgb(37, 198, 175)",
    "rgb(1, 157, 126)",
    "rgb(1, 125, 98)",
    "rgb(1, 90, 74)",
    "rgb(214, 245, 238)",
    "rgb(181, 237, 228)",
    "rgb(130, 222, 209)",
    "rgb(35, 196, 176)",
    "rgb(1, 155, 128)",
    "rgb(1, 123, 100)",
    "rgb(1, 91, 73)",
    "rgb(217, 244, 237)",
    "rgb(187, 235, 227)",
    "rgb(140, 217, 206)",
    "rgb(76, 189, 172)",
    "rgb(1, 145, 123)",
    "rgb(1, 108, 92)",
    "rgb(24, 75, 68)",
    "rgb(212, 242, 239)",
    "rgb(180, 233, 231)",
    "rgb(127, 214, 213)",
    "rgb(32, 186, 181)",
    "rgb(1, 140, 133)",
    "rgb(1, 110, 103)",
    "rgb(1, 79, 75)",
    "rgb(221, 241, 238)",
    "rgb(193, 228, 228)",
    "rgb(153, 207, 209)",
    "rgb(98, 173, 175)",
    "rgb(42, 120, 124)",
    "rgb(35, 91, 94)",
    "rgb(40, 65, 68)",
    "rgb(222, 241, 237)",
    "rgb(197, 228, 226)",
    "rgb(158, 206, 204)",
    "rgb(110, 170, 168)",
    "rgb(63, 116, 114)",
    "rgb(51, 87, 85)",
    "rgb(48, 63, 63)",
    "rgb(217, 236, 234)",
    "rgb(191, 221, 222)",
    "rgb(149, 195, 198)",
    "rgb(99, 160, 161)",
    "rgb(49, 111, 110)",
    "rgb(46, 94, 91)",
    "rgb(48, 84, 80)",
    "rgb(214, 236, 235)",
    "rgb(180, 220, 223)",
    "rgb(134, 194, 201)",
    "rgb(74, 159, 162)",
    "rgb(1, 113, 109)",
    "rgb(11, 91, 83)",
    "rgb(29, 79, 67)",
    "rgb(215, 235, 237)",
    "rgb(185, 219, 225)",
    "rgb(142, 194, 203)",
    "rgb(87, 157, 166)",
    "rgb(36, 110, 116)",
    "rgb(38, 91, 95)",
    "rgb(42, 79, 80)",
    "rgb(211, 235, 237)",
    "rgb(177, 219, 228)",
    "rgb(129, 193, 208)",
    "rgb(65, 157, 173)",
    "rgb(1, 108, 119)",
    "rgb(11, 87, 91)",
    "rgb(30, 70, 68)",
    "rgb(210, 240, 242)",
    "rgb(175, 226, 235)",
    "rgb(121, 204, 219)",
    "rgb(19, 172, 191)",
    "rgb(1, 124, 143)",
    "rgb(1, 96, 112)",
    "rgb(21, 70, 83)",
    "rgb(212, 241, 241)",
    "rgb(176, 228, 234)",
    "rgb(123, 208, 218)",
    "rgb(25, 176, 188)",
    "rgb(1, 129, 140)",
    "rgb(1, 100, 109)",
    "rgb(12, 71, 79)",
    "rgb(214, 236, 239)",
    "rgb(182, 219, 229)",
    "rgb(136, 193, 210)",
    "rgb(78, 157, 175)",
    "rgb(20, 108, 124)",
    "rgb(32, 88, 100)",
    "rgb(38, 74, 83)",
    "rgb(211, 235, 241)",
    "rgb(177, 218, 233)",
    "rgb(129, 192, 216)",
    "rgb(66, 155, 184)",
    "rgb(1, 106, 134)",
    "rgb(25, 85, 107)",
    "rgb(38, 69, 86)",
    "rgb(208, 237, 243)",
    "rgb(171, 221, 239)",
    "rgb(119, 197, 227)",
    "rgb(24, 162, 201)",
    "rgb(1, 114, 157)",
    "rgb(1, 87, 125)",
    "rgb(30, 63, 90)",
    "rgb(207, 236, 244)",
    "rgb(170, 220, 240)",
    "rgb(116, 194, 229)",
    "rgb(26, 160, 205)",
    "rgb(1, 111, 162)",
    "rgb(1, 84, 130)",
    "rgb(33, 60, 94)",
    "rgb(206, 232, 242)",
    "rgb(173, 214, 234)",
    "rgb(125, 184, 215)",
    "rgb(63, 145, 185)",
    "rgb(25, 94, 131)",
    "rgb(39, 73, 101)",
    "rgb(48, 58, 76)",
    "rgb(212, 232, 238)",
    "rgb(180, 212, 226)",
    "rgb(136, 182, 204)",
    "rgb(85, 142, 168)",
    "rgb(46, 90, 113)",
    "rgb(49, 71, 87)",
    "rgb(51, 59, 68)",
    "rgb(212, 233, 242)",
    "rgb(178, 215, 235)",
    "rgb(133, 188, 221)",
    "rgb(75, 148, 191)",
    "rgb(27, 95, 138)",
    "rgb(38, 71, 106)",
    "rgb(47, 54, 74)",
    "rgb(205, 233, 244)",
    "rgb(169, 214, 240)",
    "rgb(117, 187, 228)",
    "rgb(50, 150, 203)",
    "rgb(1, 99, 161)",
    "rgb(25, 75, 125)",
    "rgb(44, 54, 89)",
    "rgb(201, 231, 244)",
    "rgb(164, 213, 241)",
    "rgb(111, 185, 230)",
    "rgb(29, 149, 209)",
    "rgb(1, 100, 167)",
    "rgb(21, 76, 135)",
    "rgb(44, 56, 99)",
    "rgb(203, 233, 244)",
    "rgb(164, 215, 243)",
    "rgb(109, 187, 235)",
    "rgb(16, 152, 217)",
    "rgb(1, 103, 178)",
    "rgb(1, 79, 148)",
    "rgb(36, 57, 115)",
    "rgb(216, 230, 243)",
    "rgb(189, 211, 238)",
    "rgb(147, 180, 225)",
    "rgb(99, 138, 199)",
    "rgb(55, 85, 151)",
    "rgb(52, 65, 119)",
    "rgb(52, 52, 87)",
    "rgb(227, 230, 242)",
    "rgb(204, 208, 235)",
    "rgb(171, 177, 220)",
    "rgb(128, 133, 191)",
    "rgb(79, 79, 141)",
    "rgb(66, 62, 110)",
    "rgb(59, 53, 81)",
    "rgb(233, 233, 240)",
    "rgb(215, 214, 230)",
    "rgb(185, 186, 211)",
    "rgb(143, 144, 177)",
    "rgb(93, 91, 125)",
    "rgb(73, 69, 95)",
    "rgb(61, 57, 70)",
    "rgb(230, 230, 238)",
    "rgb(208, 208, 225)",
    "rgb(176, 176, 204)",
    "rgb(136, 131, 167)",
    "rgb(85, 78, 110)",
    "rgb(70, 61, 81)",
    "rgb(60, 52, 58)",
    "rgb(235, 228, 241)",
    "rgb(220, 207, 233)",
    "rgb(192, 174, 216)",
    "rgb(155, 129, 186)",
    "rgb(103, 76, 135)",
    "rgb(83, 61, 105)",
    "rgb(68, 52, 78)",
    "rgb(236, 228, 235)",
    "rgb(218, 205, 220)",
    "rgb(190, 172, 195)",
    "rgb(150, 127, 154)",
    "rgb(97, 76, 99)",
    "rgb(78, 62, 76)",
    "rgb(65, 55, 61)",
    "rgb(241, 228, 237)",
    "rgb(228, 205, 225)",
    "rgb(205, 173, 203)",
    "rgb(171, 128, 166)",
    "rgb(119, 76, 111)",
    "rgb(94, 62, 85)",
    "rgb(76, 54, 65)",
    "rgb(246, 228, 240)",
    "rgb(238, 206, 231)",
    "rgb(221, 173, 212)",
    "rgb(195, 129, 181)",
    "rgb(156, 75, 129)",
    "rgb(124, 61, 100)",
    "rgb(99, 52, 75)",
    "rgb(247, 228, 240)",
    "rgb(238, 205, 229)",
    "rgb(224, 171, 210)",
    "rgb(199, 126, 176)",
    "rgb(160, 73, 126)",
    "rgb(128, 60, 96)",
    "rgb(103, 52, 72)",
    "rgb(248, 227, 238)",
    "rgb(244, 203, 228)",
    "rgb(233, 170, 209)",
    "rgb(215, 125, 177)",
    "rgb(181, 69, 124)",
    "rgb(161, 55, 96)",
    "rgb(142, 46, 73)",
    "rgb(249, 227, 239)",
    "rgb(245, 204, 230)",
    "rgb(236, 169, 212)",
    "rgb(220, 124, 181)",
    "rgb(189, 67, 128)",
    "rgb(172, 50, 99)",
    "rgb(157, 41, 76)",
    "rgb(249, 230, 237)",
    "rgb(246, 209, 226)",
    "rgb(237, 177, 203)",
    "rgb(221, 134, 167)",
    "rgb(190, 81, 113)",
    "rgb(173, 62, 89)",
    "rgb(158, 53, 73)",
    "rgb(251, 227, 237)",
    "rgb(249, 206, 226)",
    "rgb(243, 172, 204)",
    "rgb(229, 126, 168)",
    "rgb(201, 69, 113)",
    "rgb(185, 50, 84)",
    "rgb(171, 38, 61)",
    "rgb(249, 226, 232)",
    "rgb(244, 202, 216)",
    "rgb(231, 168, 189)",
    "rgb(209, 122, 146)",
    "rgb(174, 73, 92)",
    "rgb(159, 60, 70)",
    "rgb(147, 54, 57)",
    "rgb(249, 232, 235)",
    "rgb(246, 213, 221)",
    "rgb(238, 183, 196)",
    "rgb(221, 141, 156)",
    "rgb(191, 91, 104)",
    "rgb(175, 73, 84)",
    "rgb(162, 65, 73)",
    "rgb(244, 227, 231)",
    "rgb(234, 205, 213)",
    "rgb(215, 173, 185)",
    "rgb(184, 128, 141)",
    "rgb(141, 81, 90)",
    "rgb(125, 70, 72)",
    "rgb(113, 63, 61)",
    "rgb(246, 228, 235)",
    "rgb(237, 204, 219)",
    "rgb(221, 171, 194)",
    "rgb(195, 127, 155)",
    "rgb(152, 77, 101)",
    "rgb(132, 64, 78)",
    "rgb(116, 57, 64)",
    "rgb(251, 229, 233)",
    "rgb(247, 208, 218)",
    "rgb(235, 175, 191)",
    "rgb(213, 131, 150)",
    "rgb(179, 83, 94)",
    "rgb(146, 69, 68)",
    "rgb(122, 60, 50)",
    "rgb(249, 228, 233)",
    "rgb(240, 206, 218)",
    "rgb(229, 173, 193)",
    "rgb(204, 127, 150)",
    "rgb(167, 79, 94)",
    "rgb(134, 64, 69)",
    "rgb(111, 56, 50)",
    "rgb(252, 228, 235)",
    "rgb(251, 206, 222)",
    "rgb(246, 172, 198)",
    "rgb(234, 124, 158)",
    "rgb(208, 70, 103)",
    "rgb(193, 51, 75)",
    "rgb(180, 40, 54)",
    "rgb(251, 232, 234)",
    "rgb(251, 213, 220)",
    "rgb(247, 183, 196)",
    "rgb(236, 139, 154)",
    "rgb(212, 84, 98)",
    "rgb(198, 62, 71)",
    "rgb(185, 46, 52)",
    "rgb(247, 218, 213)",
    "rgb(237, 190, 184)",
    "rgb(218, 154, 147)",
    "rgb(190, 110, 101)",
    "rgb(160, 76, 62)",
    "rgb(155, 71, 56)",
    "rgb(151, 68, 52)",
    "rgb(250, 237, 232)",
    "rgb(247, 220, 215)",
    "rgb(239, 193, 187)",
    "rgb(224, 156, 146)",
    "rgb(195, 109, 97)",
    "rgb(182, 95, 80)",
    "rgb(170, 85, 70)",
    "rgb(248, 219, 214)",
    "rgb(238, 193, 186)",
    "rgb(219, 156, 149)",
    "rgb(192, 113, 102)",
    "rgb(162, 77, 63)",
    "rgb(156, 73, 56)",
    "rgb(152, 69, 53)",
    "rgb(244, 219, 214)",
    "rgb(232, 192, 187)",
    "rgb(210, 155, 150)",
    "rgb(180, 112, 104)",
    "rgb(152, 77, 63)",
    "rgb(143, 72, 57)",
    "rgb(138, 68, 53)",
    "rgb(241, 220, 216)",
    "rgb(228, 194, 190)",
    "rgb(204, 159, 154)",
    "rgb(170, 114, 106)",
    "rgb(135, 76, 65)",
    "rgb(129, 71, 57)",
    "rgb(124, 67, 52)",
    "rgb(246, 235, 232)",
    "rgb(243, 219, 216)",
    "rgb(230, 191, 188)",
    "rgb(207, 150, 143)",
    "rgb(175, 102, 88)",
    "rgb(140, 81, 67)",
    "rgb(118, 68, 50)",
    "rgb(247, 233, 227)",
    "rgb(239, 213, 207)",
    "rgb(222, 183, 175)",
    "rgb(194, 141, 129)",
    "rgb(152, 93, 76)",
    "rgb(135, 78, 60)",
    "rgb(124, 70, 51)",
    "rgb(239, 227, 220)",
    "rgb(224, 204, 195)",
    "rgb(199, 171, 161)",
    "rgb(165, 129, 116)",
    "rgb(127, 89, 74)",
    "rgb(118, 80, 64)",
    "rgb(112, 76, 60)",
    "rgb(241, 229, 221)",
    "rgb(227, 208, 197)",
    "rgb(203, 176, 162)",
    "rgb(170, 134, 116)",
    "rgb(131, 92, 73)",
    "rgb(121, 83, 64)",
    "rgb(114, 78, 58)",
    "rgb(238, 227, 221)",
    "rgb(222, 204, 196)",
    "rgb(196, 171, 162)",
    "rgb(160, 128, 116)",
    "rgb(123, 88, 74)",
    "rgb(113, 79, 65)",
    "rgb(108, 75, 61)",
    "rgb(237, 227, 221)",
    "rgb(220, 203, 196)",
    "rgb(193, 170, 162)",
    "rgb(156, 126, 116)",
    "rgb(121, 86, 73)",
    "rgb(110, 77, 64)",
    "rgb(104, 72, 59)",
    "rgb(238, 226, 219)",
    "rgb(223, 203, 195)",
    "rgb(198, 170, 160)",
    "rgb(162, 126, 114)",
    "rgb(125, 86, 72)",
    "rgb(116, 78, 63)",
    "rgb(111, 74, 59)",
    "rgb(239, 226, 220)",
    "rgb(225, 204, 196)",
    "rgb(199, 171, 161)",
    "rgb(165, 128, 116)",
    "rgb(126, 87, 73)",
    "rgb(118, 79, 64)",
    "rgb(111, 74, 58)",
    "rgb(240, 227, 222)",
    "rgb(225, 204, 198)",
    "rgb(201, 171, 164)",
    "rgb(166, 128, 118)",
    "rgb(127, 86, 75)",
    "rgb(117, 78, 65)",
    "rgb(112, 73, 60)",
    "rgb(240, 227, 223)",
    "rgb(226, 204, 200)",
    "rgb(203, 172, 167)",
    "rgb(168, 128, 121)",
    "rgb(128, 86, 76)",
    "rgb(118, 77, 65)",
    "rgb(112, 72, 60)",
    "rgb(237, 222, 219)",
    "rgb(220, 196, 193)",
    "rgb(192, 160, 157)",
    "rgb(155, 115, 110)",
    "rgb(118, 76, 66)",
    "rgb(110, 68, 57)",
    "rgb(105, 65, 53)",
    "rgb(237, 221, 218)",
    "rgb(222, 196, 193)",
    "rgb(194, 159, 156)",
    "rgb(159, 115, 110)",
    "rgb(125, 76, 67)",
    "rgb(117, 70, 58)",
    "rgb(114, 67, 54)",
    "rgb(237, 226, 219)",
    "rgb(222, 202, 194)",
    "rgb(196, 170, 160)",
    "rgb(161, 127, 114)",
    "rgb(123, 87, 73)",
    "rgb(115, 79, 64)",
    "rgb(109, 74, 59)",
    "rgb(237, 228, 221)",
    "rgb(221, 206, 198)",
    "rgb(194, 173, 163)",
    "rgb(157, 130, 117)",
    "rgb(118, 88, 74)",
    "rgb(110, 79, 64)",
    "rgb(104, 74, 59)",
    "rgb(235, 229, 223)",
    "rgb(217, 208, 200)",
    "rgb(190, 176, 167)",
    "rgb(152, 133, 120)",
    "rgb(112, 90, 76)",
    "rgb(103, 80, 65)",
    "rgb(98, 75, 60)",
    "rgb(233, 230, 224)",
    "rgb(212, 208, 200)",
    "rgb(185, 178, 168)",
    "rgb(146, 134, 121)",
    "rgb(106, 91, 77)",
    "rgb(97, 79, 65)",
    "rgb(94, 76, 62)",
    "rgb(231, 227, 223)",
    "rgb(212, 205, 200)",
    "rgb(182, 172, 168)",
    "rgb(143, 128, 122)",
    "rgb(105, 86, 78)",
    "rgb(97, 78, 69)",
    "rgb(89, 70, 60)",
    "rgb(243, 238, 233)",
    "rgb(233, 222, 217)",
    "rgb(212, 196, 190)",
    "rgb(182, 158, 149)",
    "rgb(137, 107, 90)",
    "rgb(111, 85, 65)",
    "rgb(91, 69, 49)",
    "rgb(231, 229, 224)",
    "rgb(212, 209, 202)",
    "rgb(181, 176, 169)",
    "rgb(141, 133, 123)",
    "rgb(105, 88, 75)",
    "rgb(96, 76, 61)",
    "rgb(90, 68, 53)",
    "rgb(229, 228, 225)",
    "rgb(206, 205, 203)",
    "rgb(175, 172, 171)",
    "rgb(135, 129, 127)",
    "rgb(96, 85, 79)",
    "rgb(87, 74, 67)",
    "rgb(83, 69, 61)",
    "rgb(229, 223, 222)",
    "rgb(209, 198, 198)",
    "rgb(178, 163, 165)",
    "rgb(138, 117, 118)",
    "rgb(103, 76, 72)",
    "rgb(96, 68, 61)",
    "rgb(92, 64, 55)",
    "rgb(237, 232, 230)",
    "rgb(221, 213, 212)",
    "rgb(195, 182, 184)",
    "rgb(157, 138, 138)",
    "rgb(105, 86, 84)",
    "rgb(83, 68, 63)",
    "rgb(68, 56, 50)",
    "rgb(237, 234, 233)",
    "rgb(223, 217, 219)",
    "rgb(197, 188, 193)",
    "rgb(162, 146, 150)",
    "rgb(112, 92, 93)",
    "rgb(89, 72, 69)",
    "rgb(74, 59, 52)",
    "rgb(236, 234, 235)",
    "rgb(221, 215, 222)",
    "rgb(194, 186, 197)",
    "rgb(156, 143, 157)",
    "rgb(108, 91, 101)",
    "rgb(85, 71, 74)",
    "rgb(69, 59, 55)",
    "rgb(230, 228, 232)",
    "rgb(209, 206, 215)",
    "rgb(177, 173, 188)",
    "rgb(134, 126, 144)",
    "rgb(82, 75, 89)",
    "rgb(66, 62, 69)",
    "rgb(57, 54, 56)",
    "rgb(226, 227, 230)",
    "rgb(203, 205, 212)",
    "rgb(170, 172, 183)",
    "rgb(124, 125, 137)",
    "rgb(75, 75, 84)",
    "rgb(61, 60, 65)",
    "rgb(54, 53, 54)",
    "rgb(224, 227, 228)",
    "rgb(199, 204, 208)",
    "rgb(163, 170, 178)",
    "rgb(118, 124, 132)",
    "rgb(71, 75, 81)",
    "rgb(59, 60, 64)",
    "rgb(52, 52, 53)",
    "rgb(224, 228, 228)",
    "rgb(199, 204, 208)",
    "rgb(164, 171, 177)",
    "rgb(118, 124, 131)",
    "rgb(71, 74, 80)",
    "rgb(59, 61, 63)",
    "rgb(52, 52, 53)",
    "rgb(245, 247, 242)",
    "rgb(237, 240, 237)",
    "rgb(221, 226, 226)",
    "rgb(196, 201, 204)",
    "rgb(152, 157, 160)",
    "rgb(121, 124, 126)",
    "rgb(88, 88, 88)",
    "rgb(242, 246, 242)",
    "rgb(234, 240, 238)",
    "rgb(215, 225, 225)",
    "rgb(187, 201, 202)",
    "rgb(144, 158, 159)",
    "rgb(111, 125, 126)",
    "rgb(76, 88, 87)",
    "rgb(242, 245, 242)",
    "rgb(232, 240, 237)",
    "rgb(212, 226, 226)",
    "rgb(180, 201, 201)",
    "rgb(137, 159, 159)",
    "rgb(99, 125, 123)",
    "rgb(71, 90, 87)",
    "rgb(243, 245, 242)",
    "rgb(233, 236, 235)",
    "rgb(215, 220, 221)",
    "rgb(185, 190, 193)",
    "rgb(140, 145, 149)",
    "rgb(106, 110, 113)",
    "rgb(74, 75, 76)",
    "rgb(239, 241, 239)",
    "rgb(225, 229, 229)",
    "rgb(200, 206, 210)",
    "rgb(163, 170, 175)",
    "rgb(110, 116, 121)",
    "rgb(83, 87, 91)",
    "rgb(62, 64, 65)",
    "rgb(235, 238, 236)",
    "rgb(216, 221, 223)",
    "rgb(187, 194, 199)",
    "rgb(147, 154, 159)",
    "rgb(93, 98, 104)",
    "rgb(71, 75, 78)",
    "rgb(57, 58, 59)",
    "rgb(222, 227, 228)",
    "rgb(197, 204, 209)",
    "rgb(161, 171, 178)",
    "rgb(115, 125, 132)",
    "rgb(69, 75, 81)",
    "rgb(56, 59, 62)",
    "rgb(53, 53, 54)",
    "rgb(228, 234, 236)",
    "rgb(206, 216, 223)",
    "rgb(173, 187, 201)",
    "rgb(131, 145, 161)",
    "rgb(82, 91, 104)",
    "rgb(67, 69, 76)",
    "rgb(58, 56, 55)",
    "rgb(220, 228, 230)",
    "rgb(194, 206, 212)",
    "rgb(157, 174, 184)",
    "rgb(110, 127, 138)",
    "rgb(65, 76, 85)",
    "rgb(56, 61, 66)",
    "rgb(51, 53, 55)",
    "rgb(221, 226, 229)",
    "rgb(194, 203, 210)",
    "rgb(157, 169, 180)",
    "rgb(114, 125, 135)",
    "rgb(80, 79, 84)",
    "rgb(74, 67, 67)",
    "rgb(70, 61, 58)",
    "rgb(222, 230, 230)",
    "rgb(197, 208, 211)",
    "rgb(162, 177, 181)",
    "rgb(115, 131, 136)",
    "rgb(68, 79, 83)",
    "rgb(56, 62, 64)",
    "rgb(50, 53, 54)",
    "rgb(222, 226, 226)",
    "rgb(196, 202, 206)",
    "rgb(159, 168, 174)",
    "rgb(114, 122, 129)",
    "rgb(69, 73, 78)",
    "rgb(57, 59, 61)",
    "rgb(50, 50, 51)",
    "rgb(227, 229, 228)",
    "rgb(204, 207, 209)",
    "rgb(171, 175, 180)",
    "rgb(125, 128, 133)",
    "rgb(76, 76, 80)",
    "rgb(62, 62, 63)",
    "rgb(54, 53, 53)",
    "rgb(226, 229, 228)",
    "rgb(202, 207, 207)",
    "rgb(168, 175, 177)",
    "rgb(127, 131, 132)",
    "rgb(88, 86, 84)",
    "rgb(81, 75, 70)",
    "rgb(76, 68, 62)",
    "rgb(229, 238, 236)",
    "rgb(207, 222, 224)",
    "rgb(174, 196, 201)",
    "rgb(131, 156, 162)",
    "rgb(86, 102, 108)",
    "rgb(68, 77, 80)",
    "rgb(58, 62, 61)",
    "rgb(221, 232, 231)",
    "rgb(196, 213, 213)",
    "rgb(159, 182, 185)",
    "rgb(112, 138, 140)",
    "rgb(66, 85, 88)",
    "rgb(55, 65, 67)",
    "rgb(49, 54, 55)",
    "rgb(231, 233, 226)",
    "rgb(212, 213, 205)",
    "rgb(180, 182, 172)",
    "rgb(142, 141, 128)",
    "rgb(101, 94, 79)",
    "rgb(91, 80, 65)",
    "rgb(85, 73, 58)",
    "rgb(229, 233, 227)",
    "rgb(208, 214, 206)",
    "rgb(177, 185, 175)",
    "rgb(134, 142, 130)",
    "rgb(96, 95, 81)",
    "rgb(86, 81, 67)",
    "rgb(80, 74, 60)",
    "rgb(235, 239, 234)",
    "rgb(219, 225, 219)",
    "rgb(193, 201, 194)",
    "rgb(154, 162, 151)",
    "rgb(110, 109, 95)",
    "rgb(87, 84, 69)",
    "rgb(71, 67, 52)",
    "rgb(232, 234, 227)",
    "rgb(215, 217, 208)",
    "rgb(186, 188, 178)",
    "rgb(146, 147, 133)",
    "rgb(98, 99, 84)",
    "rgb(85, 85, 72)",
    "rgb(76, 76, 64)",
    "rgb(237, 237, 228)",
    "rgb(219, 220, 208)",
    "rgb(192, 193, 178)",
    "rgb(155, 153, 134)",
    "rgb(107, 105, 86)",
    "rgb(93, 91, 72)",
    "rgb(84, 82, 65)",
    "rgb(238, 238, 228)",
    "rgb(225, 223, 209)",
    "rgb(201, 198, 179)",
    "rgb(164, 160, 133)",
    "rgb(118, 113, 86)",
    "rgb(106, 101, 74)",
    "rgb(95, 91, 67)",
    "rgb(247, 247, 238)",
    "rgb(240, 239, 228)",
    "rgb(227, 225, 210)",
    "rgb(204, 200, 177)",
    "rgb(166, 157, 122)",
    "rgb(142, 132, 95)",
    "rgb(119, 109, 76)",
    "rgb(247, 248, 239)",
    "rgb(239, 240, 230)",
    "rgb(225, 228, 213)",
    "rgb(201, 203, 179)",
    "rgb(161, 163, 127)",
    "rgb(132, 134, 95)",
    "rgb(101, 104, 67)",
    "rgb(246, 247, 236)",
    "rgb(241, 241, 224)",
    "rgb(228, 229, 203)",
    "rgb(205, 205, 164)",
    "rgb(167, 166, 109)",
    "rgb(140, 141, 81)",
    "rgb(111, 117, 59)",
    "rgb(248, 248, 232)",
    "rgb(243, 242, 216)",
    "rgb(232, 230, 190)",
    "rgb(212, 208, 144)",
    "rgb(178, 174, 86)",
    "rgb(155, 153, 62)",
    "rgb(132, 136, 47)",
    "rgb(245, 245, 228)",
    "rgb(237, 237, 208)",
    "rgb(222, 221, 178)",
    "rgb(197, 194, 133)",
    "rgb(162, 158, 83)",
    "rgb(149, 146, 71)",
    "rgb(141, 137, 64)",
    "rgb(248, 246, 236)",
    "rgb(243, 239, 222)",
    "rgb(232, 224, 198)",
    "rgb(212, 198, 158)",
    "rgb(178, 157, 105)",
    "rgb(158, 136, 83)",
    "rgb(140, 120, 69)",
    "rgb(246, 244, 228)",
    "rgb(238, 233, 208)",
    "rgb(223, 215, 176)",
    "rgb(199, 186, 133)",
    "rgb(172, 150, 85)",
    "rgb(150, 135, 74)",
    "rgb(140, 126, 68)",
    "rgb(248, 245, 227)",
    "rgb(243, 236, 206)",
    "rgb(232, 221, 175)",
    "rgb(212, 195, 130)",
    "rgb(187, 161, 80)",
    "rgb(169, 148, 68)",
    "rgb(160, 141, 64)",
    "rgb(246, 243, 226)",
    "rgb(241, 233, 204)",
    "rgb(233, 217, 174)",
    "rgb(211, 187, 128)",
    "rgb(188, 154, 82)",
    "rgb(173, 142, 71)",
    "rgb(161, 134, 67)",
    "rgb(250, 246, 230)",
    "rgb(248, 237, 211)",
    "rgb(240, 222, 182)",
    "rgb(225, 196, 138)",
    "rgb(198, 159, 86)",
    "rgb(185, 145, 70)",
    "rgb(174, 135, 63)",
    "rgb(249, 242, 222)",
    "rgb(243, 229, 198)",
    "rgb(231, 208, 162)",
    "rgb(210, 177, 114)",
    "rgb(176, 137, 65)",
    "rgb(161, 123, 54)",
    "rgb(151, 115, 47)",
    "rgb(251, 244, 225)",
    "rgb(251, 236, 205)",
    "rgb(246, 219, 170)",
    "rgb(235, 194, 125)",
    "rgb(214, 162, 76)",
    "rgb(205, 150, 62)",
    "rgb(198, 143, 57)",
    "rgb(252, 245, 221)",
    "rgb(253, 236, 196)",
    "rgb(252, 221, 160)",
    "rgb(245, 196, 108)",
    "rgb(235, 168, 50)",
    "rgb(221, 147, 35)",
    "rgb(215, 139, 27)",
    "rgb(252, 243, 221)",
    "rgb(252, 232, 198)",
    "rgb(249, 212, 162)",
    "rgb(237, 180, 110)",
    "rgb(216, 141, 60)",
    "rgb(205, 128, 46)",
    "rgb(198, 119, 39)",
    "rgb(252, 243, 229)",
    "rgb(253, 232, 208)",
    "rgb(250, 214, 177)",
    "rgb(239, 184, 132)",
    "rgb(217, 145, 81)",
    "rgb(206, 132, 66)",
    "rgb(198, 124, 59)",
    "rgb(251, 244, 228)",
    "rgb(251, 233, 207)",
    "rgb(245, 215, 175)",
    "rgb(233, 186, 130)",
    "rgb(210, 152, 81)",
    "rgb(199, 136, 70)",
    "rgb(191, 128, 63)",
    "rgb(251, 244, 227)",
    "rgb(252, 235, 206)",
    "rgb(248, 219, 174)",
    "rgb(237, 192, 128)",
    "rgb(215, 158, 78)",
    "rgb(205, 145, 65)",
    "rgb(197, 138, 59)",
    "rgb(250, 243, 225)",
    "rgb(249, 233, 205)",
    "rgb(241, 214, 173)",
    "rgb(225, 186, 128)",
    "rgb(202, 152, 80)",
    "rgb(187, 136, 69)",
    "rgb(179, 129, 62)",
    "rgb(248, 240, 226)",
    "rgb(242, 226, 205)",
    "rgb(228, 202, 171)",
    "rgb(206, 169, 128)",
    "rgb(172, 127, 82)",
    "rgb(160, 115, 72)",
    "rgb(151, 108, 66)",
    "rgb(246, 237, 221)",
    "rgb(237, 221, 198)",
    "rgb(220, 196, 165)",
    "rgb(193, 158, 116)",
    "rgb(154, 115, 70)",
    "rgb(141, 103, 60)",
    "rgb(132, 95, 53)",
    "rgb(245, 236, 224)",
    "rgb(236, 220, 203)",
    "rgb(219, 193, 171)",
    "rgb(191, 154, 125)",
    "rgb(153, 111, 80)",
    "rgb(142, 100, 70)",
    "rgb(134, 93, 64)",
    "rgb(243, 233, 222)",
    "rgb(231, 213, 197)",
    "rgb(210, 184, 164)",
    "rgb(178, 143, 117)",
    "rgb(139, 100, 73)",
    "rgb(127, 89, 62)",
    "rgb(119, 82, 57)",
    "rgb(249, 242, 226)",
    "rgb(246, 230, 205)",
    "rgb(236, 211, 174)",
    "rgb(217, 179, 130)",
    "rgb(187, 140, 83)",
    "rgb(175, 127, 71)",
    "rgb(166, 119, 63)",
    "rgb(251, 238, 220)",
    "rgb(250, 223, 196)",
    "rgb(242, 198, 161)",
    "rgb(226, 162, 110)",
    "rgb(200, 120, 63)",
    "rgb(189, 108, 51)",
    "rgb(182, 100, 45)",
    "rgb(253, 242, 229)",
    "rgb(254, 229, 210)",
    "rgb(252, 208, 180)",
    "rgb(242, 175, 133)",
    "rgb(220, 133, 81)",
    "rgb(209, 119, 65)",
    "rgb(200, 109, 56)",
    "rgb(253, 240, 229)",
    "rgb(254, 228, 210)",
    "rgb(252, 205, 180)",
    "rgb(243, 172, 134)",
    "rgb(221, 129, 83)",
    "rgb(210, 113, 67)",
    "rgb(201, 103, 57)",
    "rgb(254, 239, 230)",
    "rgb(255, 225, 212)",
    "rgb(254, 201, 183)",
    "rgb(246, 164, 135)",
    "rgb(226, 120, 82)",
    "rgb(213, 102, 63)",
    "rgb(205, 91, 51)",
    "rgb(251, 238, 228)",
    "rgb(250, 222, 208)",
    "rgb(245, 196, 179)",
    "rgb(235, 159, 131)",
    "rgb(214, 111, 79)",
    "rgb(204, 95, 62)",
    "rgb(196, 83, 51)",
    "rgb(253, 235, 231)",
    "rgb(254, 219, 214)",
    "rgb(249, 191, 185)",
    "rgb(235, 150, 138)",
    "rgb(212, 103, 82)",
    "rgb(190, 85, 62)",
    "rgb(172, 73, 49)",
    "rgb(245, 218, 214)",
    "rgb(235, 192, 186)",
    "rgb(214, 155, 149)",
    "rgb(184, 113, 104)",
    "rgb(155, 76, 62)",
    "rgb(147, 72, 56)",
    "rgb(143, 68, 51)",
    "rgb(248, 233, 227)",
    "rgb(241, 214, 207)",
    "rgb(227, 185, 177)",
    "rgb(201, 142, 130)",
    "rgb(159, 94, 76)",
    "rgb(142, 79, 59)",
    "rgb(129, 70, 50)",
    "rgb(250, 234, 229)",
    "rgb(245, 216, 210)",
    "rgb(233, 188, 181)",
    "rgb(211, 146, 134)",
    "rgb(172, 97, 79)",
    "rgb(153, 80, 60)",
    "rgb(137, 69, 47)",
    "rgb(250, 232, 219)",
    "rgb(247, 213, 194)",
    "rgb(235, 182, 158)",
    "rgb(213, 142, 109)",
    "rgb(183, 100, 65)",
    "rgb(174, 90, 54)",
    "rgb(167, 84, 49)",
    "rgb(204, 206, 203)",
    "rgb(154, 149, 147)",
    "rgb(109, 108, 110)",
    "rgb(147, 148, 147)",
    "rgb(133, 130, 130)",
    "rgb(60, 51, 49)",
    "rgb(213, 209, 196)",
    "rgb(177, 173, 164)",
    "rgb(133, 133, 129)",
    "rgb(147, 150, 146)",
    "rgb(114, 118, 114)",
    "rgb(99, 101, 100)",
    "rgb(197, 187, 172)",
    "rgb(176, 168, 156)",
    "rgb(145, 138, 129)",
    "rgb(158, 151, 141)",
    "rgb(136, 131, 122)",
    "rgb(107, 100, 94)",
    "rgb(213, 208, 196)",
    "rgb(188, 183, 170)",
    "rgb(178, 174, 163)",
    "rgb(161, 159, 152)",
    "rgb(131, 127, 121)",
    "rgb(107, 106, 104)",
    "rgb(226, 225, 210)",
    "rgb(203, 200, 181)",
    "rgb(151, 141, 119)",
    "rgb(171, 164, 148)",
    "rgb(143, 138, 125)",
    "rgb(115, 111, 104)",
    "rgb(214, 208, 192)",
    "rgb(189, 182, 162)",
    "rgb(164, 155, 137)",
    "rgb(198, 191, 174)",
    "rgb(179, 172, 154)",
    "rgb(131, 124, 110)",
    "rgb(230, 225, 209)",
    "rgb(178, 166, 146)",
    "rgb(135, 123, 110)",
    "rgb(175, 165, 152)",
    "rgb(148, 139, 125)",
    "rgb(84, 72, 59)",
    "rgb(233, 225, 207)",
    "rgb(214, 204, 185)",
    "rgb(192, 182, 164)",
    "rgb(182, 163, 145)",
    "rgb(134, 118, 104)",
    "rgb(79, 68, 62)",
    "rgb(240, 235, 220)",
    "rgb(224, 212, 190)",
    "rgb(181, 164, 137)",
    "rgb(149, 132, 111)",
    "rgb(128, 109, 88)",
    "rgb(100, 80, 67)",
    "rgb(223, 209, 186)",
    "rgb(204, 184, 157)",
    "rgb(199, 169, 132)",
    "rgb(163, 128, 94)",
    "rgb(137, 100, 73)",
    "rgb(108, 79, 63)",
    "rgb(250, 247, 232)",
    "rgb(233, 223, 208)",
    "rgb(207, 193, 175)",
    "rgb(186, 156, 131)",
    "rgb(145, 99, 82)",
    "rgb(117, 71, 53)",
    "rgb(235, 226, 209)",
    "rgb(222, 205, 190)",
    "rgb(210, 186, 170)",
    "rgb(182, 157, 142)",
    "rgb(139, 111, 99)",
    "rgb(95, 60, 48)",
    "rgb(228, 224, 214)",
    "rgb(214, 209, 200)",
    "rgb(182, 170, 158)",
    "rgb(160, 143, 133)",
    "rgb(136, 127, 121)",
    "rgb(85, 67, 60)",
    "rgb(228, 223, 209)",
    "rgb(214, 204, 191)",
    "rgb(198, 184, 173)",
    "rgb(188, 169, 164)",
    "rgb(146, 121, 119)",
    "rgb(110, 89, 85)",
    "rgb(215, 188, 188)",
    "rgb(172, 106, 111)",
    "rgb(132, 68, 80)",
    "rgb(159, 64, 99)",
    "rgb(106, 59, 61)",
    "rgb(89, 48, 48)",
    "rgb(142, 144, 162)",
    "rgb(112, 98, 120)",
    "rgb(78, 52, 85)",
    "rgb(97, 47, 79)",
    "rgb(108, 95, 108)",
    "rgb(57, 42, 49)",
    "rgb(233, 234, 226)",
    "rgb(215, 211, 206)",
    "rgb(193, 189, 189)",
    "rgb(214, 214, 209)",
    "rgb(146, 138, 140)",
    "rgb(96, 90, 97)",
    "rgb(208, 213, 216)",
    "rgb(143, 164, 198)",
    "rgb(84, 98, 144)",
    "rgb(135, 145, 165)",
    "rgb(76, 75, 93)",
    "rgb(65, 61, 64)",
    "rgb(209, 222, 230)",
    "rgb(155, 179, 198)",
    "rgb(96, 143, 195)",
    "rgb(79, 114, 155)",
    "rgb(69, 88, 115)",
    "rgb(65, 68, 68)",
    "rgb(221, 223, 217)",
    "rgb(196, 200, 198)",
    "rgb(169, 176, 177)",
    "rgb(202, 207, 210)",
    "rgb(163, 177, 184)",
    "rgb(89, 101, 114)",
    "rgb(141, 165, 174)",
    "rgb(184, 207, 213)",
    "rgb(153, 193, 208)",
    "rgb(122, 143, 154)",
    "rgb(83, 91, 97)",
    "rgb(52, 57, 63)",
    "rgb(95, 164, 178)",
    "rgb(60, 153, 163)",
    "rgb(39, 119, 143)",
    "rgb(132, 161, 174)",
    "rgb(57, 108, 141)",
    "rgb(1, 72, 100)",
    "rgb(204, 212, 205)",
    "rgb(156, 176, 178)",
    "rgb(131, 162, 168)",
    "rgb(87, 134, 141)",
    "rgb(69, 101, 110)",
    "rgb(3, 60, 79)",
    "rgb(168, 200, 189)",
    "rgb(127, 183, 173)",
    "rgb(118, 160, 155)",
    "rgb(90, 126, 126)",
    "rgb(74, 111, 116)",
    "rgb(31, 73, 81)",
    "rgb(233, 231, 223)",
    "rgb(188, 196, 188)",
    "rgb(146, 159, 152)",
    "rgb(184, 199, 191)",
    "rgb(139, 160, 156)",
    "rgb(113, 125, 122)",
    "rgb(207, 207, 193)",
    "rgb(160, 162, 149)",
    "rgb(119, 120, 106)",
    "rgb(195, 201, 185)",
    "rgb(170, 182, 166)",
    "rgb(139, 159, 137)",
    "rgb(220, 224, 205)",
    "rgb(201, 209, 184)",
    "rgb(173, 175, 147)",
    "rgb(136, 146, 123)",
    "rgb(106, 118, 99)",
    "rgb(73, 83, 66)",
    "rgb(219, 218, 189)",
    "rgb(195, 191, 160)",
    "rgb(149, 149, 119)",
    "rgb(201, 204, 160)",
    "rgb(182, 185, 150)",
    "rgb(156, 164, 118)",
    "rgb(225, 220, 170)",
    "rgb(208, 204, 141)",
    "rgb(189, 185, 121)",
    "rgb(210, 211, 87)",
    "rgb(177, 190, 78)",
    "rgb(142, 174, 98)",
    "rgb(238, 234, 202)",
    "rgb(215, 209, 154)",
    "rgb(202, 192, 129)",
    "rgb(187, 184, 98)",
    "rgb(134, 126, 68)",
    "rgb(91, 86, 57)",
    "rgb(243, 232, 190)",
    "rgb(241, 224, 166)",
    "rgb(226, 203, 145)",
    "rgb(215, 190, 112)",
    "rgb(189, 164, 71)",
    "rgb(150, 127, 56)",
    "rgb(240, 233, 203)",
    "rgb(249, 229, 179)",
    "rgb(237, 209, 148)",
    "rgb(240, 218, 155)",
    "rgb(230, 195, 106)",
    "rgb(188, 145, 31)",
    "rgb(240, 231, 204)",
    "rgb(220, 195, 150)",
    "rgb(214, 184, 130)",
    "rgb(188, 158, 98)",
    "rgb(153, 127, 86)",
    "rgb(135, 112, 76)",
    "rgb(234, 225, 193)",
    "rgb(202, 189, 151)",
    "rgb(189, 169, 123)",
    "rgb(227, 209, 173)",
    "rgb(206, 189, 151)",
    "rgb(182, 160, 125)",
    "rgb(240, 237, 218)",
    "rgb(223, 215, 192)",
    "rgb(203, 193, 167)",
    "rgb(171, 158, 130)",
    "rgb(150, 132, 107)",
    "rgb(109, 94, 75)",
    "rgb(241, 231, 211)",
    "rgb(228, 207, 173)",
    "rgb(215, 179, 142)",
    "rgb(205, 153, 108)",
    "rgb(172, 114, 66)",
    "rgb(140, 93, 44)",
    "rgb(234, 203, 167)",
    "rgb(219, 175, 134)",
    "rgb(190, 129, 88)",
    "rgb(190, 114, 60)",
    "rgb(166, 86, 40)",
    "rgb(210, 115, 38)",
    "rgb(210, 129, 110)",
    "rgb(179, 108, 94)",
    "rgb(145, 85, 69)",
    "rgb(215, 151, 122)",
    "rgb(190, 123, 101)",
    "rgb(170, 89, 69)",
    "rgb(192, 64, 46)",
    "rgb(172, 64, 49)",
    "rgb(170, 53, 53)",
    "rgb(191, 112, 104)",
    "rgb(149, 70, 69)",
    "rgb(120, 58, 54)",
    "rgb(223, 133, 129)",
    "rgb(201, 100, 98)",
    "rgb(177, 99, 93)",
    "rgb(181, 78, 82)",
    "rgb(161, 37, 51)",
    "rgb(160, 36, 62)",
    "rgb(240, 223, 211)",
    "rgb(219, 202, 172)",
    "rgb(188, 179, 162)",
    "rgb(115, 87, 66)",
    "rgb(243, 242, 231)",
    "rgb(201, 203, 179)",
    "rgb(11, 87, 91)",
    "rgb(43, 70, 62)",
    "rgb(236, 238, 235)",
    "rgb(187, 201, 202)",
    "rgb(114, 125, 135)",
    "rgb(68, 76, 87)",
    "rgb(219, 215, 205)",
    "rgb(187, 190, 185)",
    "rgb(104, 103, 99)",
    "rgb(89, 57, 54)",
    "rgb(94, 77, 85)",
    "rgb(163, 138, 140)",
    "rgb(192, 165, 161)",
    "rgb(237, 239, 237)",
    "rgb(236, 238, 235)",
    "rgb(241, 242, 235)",
    "rgb(106, 54, 66)",
    "rgb(91, 55, 71)",
    "rgb(80, 60, 81)",
    "rgb(112, 102, 121)",
    "rgb(243, 242, 231)",
    "rgb(236, 231, 216)",
    "rgb(227, 213, 195)",
    "rgb(121, 58, 53)",
    "rgb(160, 63, 63)",
    "rgb(157, 47, 60)",
    "rgb(167, 57, 66)",
    "rgb(237, 235, 225)",
    "rgb(228, 224, 211)",
    "rgb(216, 206, 184)",
    "rgb(153, 73, 66)",
    "rgb(167, 77, 68)",
    "rgb(185, 110, 83)",
    "rgb(190, 101, 73)",
    "rgb(247, 241, 226)",
    "rgb(226, 215, 194)",
    "rgb(208, 187, 157)",
    "rgb(143, 81, 74)",
    "rgb(143, 64, 49)",
    "rgb(166, 90, 79)",
    "rgb(180, 106, 88)",
    "rgb(243, 240, 224)",
    "rgb(234, 222, 198)",
    "rgb(212, 193, 158)",
    "rgb(127, 75, 71)",
    "rgb(194, 134, 116)",
    "rgb(231, 190, 173)",
    "rgb(243, 219, 205)",
    "rgb(246, 239, 217)",
    "rgb(242, 229, 197)",
    "rgb(238, 216, 165)",
    "rgb(189, 140, 111)",
    "rgb(194, 137, 115)",
    "rgb(221, 171, 135)",
    "rgb(241, 202, 162)",
    "rgb(239, 224, 184)",
    "rgb(233, 212, 162)",
    "rgb(226, 195, 140)",
    "rgb(250, 216, 150)",
    "rgb(251, 226, 161)",
    "rgb(252, 236, 194)",
    "rgb(254, 239, 179)",
    "rgb(238, 230, 207)",
    "rgb(222, 212, 184)",
    "rgb(203, 185, 141)",
    "rgb(230, 197, 140)",
    "rgb(235, 208, 161)",
    "rgb(228, 218, 188)",
    "rgb(230, 216, 186)",
    "rgb(227, 220, 195)",
    "rgb(214, 201, 167)",
    "rgb(194, 183, 152)",
    "rgb(157, 111, 74)",
    "rgb(203, 165, 115)",
    "rgb(219, 190, 153)",
    "rgb(235, 211, 178)",
    "rgb(232, 220, 188)",
    "rgb(218, 202, 162)",
    "rgb(207, 186, 134)",
    "rgb(186, 154, 121)",
    "rgb(202, 173, 135)",
    "rgb(227, 211, 180)",
    "rgb(221, 205, 180)",
    "rgb(223, 209, 193)",
    "rgb(208, 189, 165)",
    "rgb(189, 167, 141)",
    "rgb(170, 143, 106)",
    "rgb(177, 153, 123)",
    "rgb(185, 162, 132)",
    "rgb(202, 180, 149)",
    "rgb(233, 221, 201)",
    "rgb(228, 196, 167)",
    "rgb(186, 136, 103)",
    "rgb(166, 142, 115)",
    "rgb(181, 160, 140)",
    "rgb(202, 176, 153)",
    "rgb(216, 195, 174)",
    "rgb(226, 208, 182)",
    "rgb(211, 172, 137)",
    "rgb(157, 97, 65)",
    "rgb(181, 157, 142)",
    "rgb(196, 185, 175)",
    "rgb(203, 190, 176)",
    "rgb(203, 186, 169)",
    "rgb(235, 213, 177)",
    "rgb(214, 180, 136)",
    "rgb(185, 142, 97)",
    "rgb(205, 186, 174)",
    "rgb(212, 197, 187)",
    "rgb(221, 212, 203)",
    "rgb(232, 222, 208)",
    "rgb(224, 207, 180)",
    "rgb(193, 168, 136)",
    "rgb(154, 125, 88)",
    "rgb(159, 141, 125)",
    "rgb(184, 170, 157)",
    "rgb(202, 191, 176)",
    "rgb(212, 202, 190)",
    "rgb(206, 197, 182)",
    "rgb(184, 171, 155)",
    "rgb(160, 143, 125)",
    "rgb(115, 88, 73)",
    "rgb(135, 97, 80)",
    "rgb(181, 151, 123)",
    "rgb(201, 173, 143)",
    "rgb(197, 187, 171)",
    "rgb(174, 163, 145)",
    "rgb(133, 116, 95)",
    "rgb(102, 90, 75)",
    "rgb(158, 136, 117)",
    "rgb(151, 136, 120)",
    "rgb(163, 158, 151)",
    "rgb(203, 197, 177)",
    "rgb(176, 166, 144)",
    "rgb(134, 123, 105)",
    "rgb(87, 79, 73)",
    "rgb(106, 105, 104)",
    "rgb(140, 133, 125)",
    "rgb(128, 126, 120)",
    "rgb(183, 185, 166)",
    "rgb(155, 157, 136)",
    "rgb(99, 101, 82)",
    "rgb(140, 131, 117)",
    "rgb(143, 130, 107)",
    "rgb(159, 145, 122)",
    "rgb(210, 198, 169)",
    "rgb(215, 219, 192)",
    "rgb(176, 179, 137)",
    "rgb(124, 129, 105)",
    "rgb(164, 160, 136)",
    "rgb(172, 159, 137)",
    "rgb(198, 196, 175)",
    "rgb(227, 232, 221)",
    "rgb(202, 209, 192)",
    "rgb(141, 154, 134)",
    "rgb(89, 99, 82)",
    "rgb(154, 147, 118)",
    "rgb(175, 170, 144)",
    "rgb(197, 195, 177)",
    "rgb(220, 215, 168)",
    "rgb(195, 210, 199)",
    "rgb(145, 164, 148)",
    "rgb(91, 114, 106)",
    "rgb(90, 83, 61)",
    "rgb(106, 104, 84)",
    "rgb(97, 99, 66)",
    "rgb(151, 155, 115)",
    "rgb(192, 199, 188)",
    "rgb(168, 180, 171)",
    "rgb(158, 169, 162)",
    "rgb(67, 73, 63)",
    "rgb(134, 132, 104)",
    "rgb(150, 146, 128)",
    "rgb(185, 185, 162)",
    "rgb(200, 208, 201)",
    "rgb(164, 177, 175)",
    "rgb(123, 133, 128)",
    "rgb(136, 137, 115)",
    "rgb(148, 153, 129)",
    "rgb(166, 171, 147)",
    "rgb(188, 199, 184)",
    "rgb(177, 202, 209)",
    "rgb(128, 158, 173)",
    "rgb(108, 137, 150)",
    "rgb(49, 73, 75)",
    "rgb(79, 109, 108)",
    "rgb(112, 144, 143)",
    "rgb(157, 173, 159)",
    "rgb(161, 191, 207)",
    "rgb(134, 161, 183)",
    "rgb(76, 91, 114)",
    "rgb(84, 115, 133)",
    "rgb(132, 185, 209)",
    "rgb(152, 196, 224)",
    "rgb(189, 213, 222)",
    "rgb(204, 222, 227)",
    "rgb(100, 136, 160)",
    "rgb(64, 83, 103)",
    "rgb(130, 166, 193)",
    "rgb(155, 181, 200)",
    "rgb(178, 192, 200)",
    "rgb(156, 178, 188)",
    "rgb(181, 198, 216)",
    "rgb(119, 134, 162)",
    "rgb(93, 107, 134)",
    "rgb(17, 86, 126)",
    "rgb(65, 115, 157)",
    "rgb(95, 144, 183)",
    "rgb(175, 212, 230)",
    "rgb(187, 204, 224)",
    "rgb(92, 110, 147)",
    "rgb(66, 75, 99)",
    "rgb(49, 77, 138)",
    "rgb(57, 99, 164)",
    "rgb(108, 142, 180)",
    "rgb(162, 192, 214)",
    "rgb(202, 209, 217)",
    "rgb(148, 161, 190)",
    "rgb(93, 99, 117)",
    "rgb(93, 122, 180)",
    "rgb(142, 174, 218)",
    "rgb(158, 179, 209)",
    "rgb(166, 184, 206)",
    "rgb(223, 227, 228)",
    "rgb(161, 167, 183)",
    "rgb(111, 114, 131)",
    "rgb(44, 60, 77)",
    "rgb(117, 126, 147)",
    "rgb(148, 167, 191)",
    "rgb(200, 214, 229)",
    "rgb(173, 180, 203)",
    "rgb(125, 130, 158)",
    "rgb(106, 110, 135)",
    "rgb(64, 66, 81)",
    "rgb(54, 58, 100)",
    "rgb(65, 71, 110)",
    "rgb(64, 70, 126)",
    "rgb(167, 167, 190)",
    "rgb(131, 128, 147)",
    "rgb(82, 77, 91)",
    "rgb(219, 212, 162)",
    "rgb(230, 220, 172)",
    "rgb(237, 229, 197)",
    "rgb(246, 226, 165)",
    "rgb(243, 230, 187)",
    "rgb(246, 234, 200)",
    "rgb(214, 167, 96)",
    "rgb(222, 183, 116)",
    "rgb(222, 192, 135)",
    "rgb(223, 185, 103)",
    "rgb(226, 197, 121)",
    "rgb(232, 206, 142)",
    "rgb(185, 157, 92)",
    "rgb(195, 171, 109)",
    "rgb(204, 187, 133)",
    "rgb(161, 140, 96)",
    "rgb(194, 169, 116)",
    "rgb(219, 203, 157)",
    "rgb(150, 129, 94)",
    "rgb(164, 144, 107)",
    "rgb(187, 169, 136)",
    "rgb(189, 165, 113)",
    "rgb(193, 177, 141)",
    "rgb(222, 205, 168)",
    "rgb(192, 175, 141)",
    "rgb(219, 203, 171)",
    "rgb(234, 230, 209)",
    "rgb(204, 182, 142)",
    "rgb(223, 207, 167)",
    "rgb(238, 222, 184)",
    "rgb(222, 203, 155)",
    "rgb(236, 220, 186)",
    "rgb(245, 227, 193)",
    "rgb(205, 177, 133)",
    "rgb(223, 205, 168)",
    "rgb(244, 230, 196)",
    "rgb(168, 137, 92)",
    "rgb(194, 168, 126)",
    "rgb(219, 202, 172)",
    "rgb(156, 114, 74)",
    "rgb(184, 146, 100)",
    "rgb(203, 164, 121)",
    "rgb(178, 151, 112)",
    "rgb(195, 175, 143)",
    "rgb(210, 195, 168)",
    "rgb(171, 138, 107)",
    "rgb(193, 167, 138)",
    "rgb(210, 190, 165)",
    "rgb(159, 99, 78)",
    "rgb(153, 90, 74)",
    "rgb(175, 108, 86)",
    "rgb(232, 180, 137)",
    "rgb(242, 203, 168)",
    "rgb(242, 214, 184)",
    "rgb(206, 170, 145)",
    "rgb(224, 194, 172)",
    "rgb(235, 212, 188)",
    "rgb(215, 180, 164)",
    "rgb(227, 201, 187)",
    "rgb(242, 218, 199)",
    "rgb(118, 76, 79)",
    "rgb(155, 110, 108)",
    "rgb(209, 175, 160)",
    "rgb(100, 70, 68)",
    "rgb(120, 78, 75)",
    "rgb(141, 90, 87)",
    "rgb(102, 86, 75)",
    "rgb(106, 90, 78)",
    "rgb(124, 109, 94)",
    "rgb(96, 80, 71)",
    "rgb(102, 77, 68)",
    "rgb(97, 82, 75)",
    "rgb(128, 103, 79)",
    "rgb(147, 115, 85)",
    "rgb(158, 120, 87)",
    "rgb(139, 120, 101)",
    "rgb(164, 147, 125)",
    "rgb(214, 203, 188)",
    "rgb(188, 172, 143)",
    "rgb(206, 193, 169)",
    "rgb(220, 211, 189)",
    "rgb(195, 182, 155)",
    "rgb(207, 198, 177)",
    "rgb(220, 212, 196)",
    "rgb(125, 114, 98)",
    "rgb(149, 135, 117)",
    "rgb(166, 155, 142)",
    "rgb(152, 133, 103)",
    "rgb(173, 157, 125)",
    "rgb(207, 196, 165)",
    "rgb(188, 172, 137)",
    "rgb(207, 191, 161)",
    "rgb(219, 210, 184)",
    "rgb(165, 155, 122)",
    "rgb(185, 175, 150)",
    "rgb(207, 200, 171)",
    "rgb(151, 142, 113)",
    "rgb(173, 162, 131)",
    "rgb(215, 207, 178)",
    "rgb(124, 119, 102)",
    "rgb(145, 138, 115)",
    "rgb(179, 170, 145)",
    "rgb(128, 120, 103)",
    "rgb(146, 139, 121)",
    "rgb(169, 163, 150)",
    "rgb(135, 128, 106)",
    "rgb(155, 151, 133)",
    "rgb(175, 169, 152)",
    "rgb(129, 125, 101)",
    "rgb(144, 142, 114)",
    "rgb(176, 172, 148)",
    "rgb(130, 129, 103)",
    "rgb(157, 159, 136)",
    "rgb(178, 184, 163)",
    "rgb(186, 184, 145)",
    "rgb(204, 206, 175)",
    "rgb(213, 219, 192)",
    "rgb(170, 182, 150)",
    "rgb(192, 204, 174)",
    "rgb(203, 216, 193)",
    "rgb(89, 107, 85)",
    "rgb(122, 129, 101)",
    "rgb(146, 158, 131)",
    "rgb(99, 113, 104)",
    "rgb(105, 119, 103)",
    "rgb(116, 128, 107)",
    "rgb(100, 133, 106)",
    "rgb(118, 155, 129)",
    "rgb(136, 172, 148)",
    "rgb(101, 129, 109)",
    "rgb(118, 150, 126)",
    "rgb(139, 172, 153)",
    "rgb(71, 91, 94)",
    "rgb(66, 88, 83)",
    "rgb(73, 97, 86)",
    "rgb(109, 146, 136)",
    "rgb(126, 162, 155)",
    "rgb(148, 182, 173)",
    "rgb(177, 187, 165)",
    "rgb(191, 202, 184)",
    "rgb(205, 213, 197)",
    "rgb(148, 170, 161)",
    "rgb(171, 191, 181)",
    "rgb(194, 210, 202)",
    "rgb(135, 153, 159)",
    "rgb(173, 192, 190)",
    "rgb(194, 209, 203)",
    "rgb(131, 161, 167)",
    "rgb(158, 183, 187)",
    "rgb(182, 201, 202)",
    "rgb(98, 135, 152)",
    "rgb(119, 159, 177)",
    "rgb(150, 186, 199)",
    "rgb(68, 76, 87)",
    "rgb(71, 86, 103)",
    "rgb(73, 92, 111)",
    "rgb(68, 82, 86)",
    "rgb(69, 90, 99)",
    "rgb(99, 121, 134)",
    "rgb(95, 109, 109)",
    "rgb(120, 135, 135)",
    "rgb(139, 151, 151)",
    "rgb(128, 135, 128)",
    "rgb(152, 160, 156)",
    "rgb(171, 179, 177)",
    "rgb(104, 103, 99)",
    "rgb(118, 119, 113)",
    "rgb(135, 133, 125)",
    "rgb(185, 187, 183)",
    "rgb(203, 204, 198)",
    "rgb(213, 217, 211)",
    "rgb(204, 199, 185)",
    "rgb(218, 212, 197)",
    "rgb(231, 226, 204)",
    "rgb(161, 153, 138)",
    "rgb(202, 191, 176)",
    "rgb(218, 199, 167)",
    "rgb(101, 104, 106)",
    "rgb(169, 170, 164)",
    "rgb(205, 209, 203)",
    "rgb(154, 11, 21)",
    "rgb(106, 25, 27)",
    "rgb(119, 45, 36)",
    "rgb(103, 43, 38)",
    "rgb(80, 59, 49)",
    "rgb(117, 83, 58)",
    "rgb(37, 47, 45)",
    "rgb(40, 55, 47)",
    "rgb(12, 66, 47)",
    "rgb(50, 50, 51)",
    "rgb(96, 119, 128)",
    "rgb(238, 240, 232)",
    "rgb(246, 243, 230)",
    "rgb(239, 236, 217)",
    "rgb(233, 228, 204)",
    "rgb(211, 200, 169)",
    "rgb(198, 189, 163)",
    "rgb(158, 145, 115)",
    "rgb(146, 139, 118)",
    "rgb(211, 204, 186)",
    "rgb(198, 191, 174)",
    "rgb(181, 173, 154)",
    "rgb(163, 153, 135)",
    "rgb(134, 132, 117)",
    "rgb(133, 123, 104)",
    "rgb(133, 126, 112)",
    "rgb(131, 125, 112)",
    "rgb(89, 89, 79)",
    "rgb(83, 80, 69)",
    "rgb(235, 228, 211)",
    "rgb(233, 226, 205)",
    "rgb(235, 225, 197)",
    "rgb(248, 236, 206)",
    "rgb(227, 212, 180)",
    "rgb(214, 196, 163)",
    "rgb(185, 164, 136)",
    "rgb(182, 161, 132)",
    "rgb(143, 118, 90)",
    "rgb(217, 206, 186)",
    "rgb(201, 189, 168)",
    "rgb(139, 123, 103)",
    "rgb(146, 134, 121)",
    "rgb(106, 91, 77)",
    "rgb(81, 57, 46)",
    "rgb(74, 57, 49)",
    "rgb(75, 65, 63)",
    "rgb(54, 46, 44)",
    "rgb(235, 215, 185)",
    "rgb(205, 176, 147)",
    "rgb(168, 135, 105)",
    "rgb(242, 232, 213)",
    "rgb(232, 205, 185)",
    "rgb(207, 166, 138)",
    "rgb(223, 157, 142)",
    "rgb(198, 143, 122)",
    "rgb(193, 143, 128)",
    "rgb(193, 113, 97)",
    "rgb(166, 102, 90)",
    "rgb(145, 102, 89)",
    "rgb(144, 82, 77)",
    "rgb(114, 50, 41)",
    "rgb(121, 61, 55)",
    "rgb(112, 70, 58)",
    "rgb(106, 62, 46)",
    "rgb(101, 66, 62)",
    "rgb(249, 234, 200)",
    "rgb(243, 206, 144)",
    "rgb(231, 179, 114)",
    "rgb(190, 126, 73)",
    "rgb(201, 114, 73)",
    "rgb(224, 117, 94)",
    "rgb(205, 117, 106)",
    "rgb(176, 93, 75)",
    "rgb(190, 71, 57)",
    "rgb(172, 73, 49)",
    "rgb(153, 90, 74)",
    "rgb(159, 64, 50)",
    "rgb(167, 69, 62)",
    "rgb(174, 68, 64)",
    "rgb(160, 70, 83)",
    "rgb(141, 81, 90)",
    "rgb(116, 69, 81)",
    "rgb(143, 128, 122)",
    "rgb(229, 203, 160)",
    "rgb(226, 197, 146)",
    "rgb(215, 175, 116)",
    "rgb(200, 150, 86)",
    "rgb(195, 156, 100)",
    "rgb(179, 139, 90)",
    "rgb(240, 214, 151)",
    "rgb(233, 206, 132)",
    "rgb(222, 182, 89)",
    "rgb(240, 230, 187)",
    "rgb(224, 207, 158)",
    "rgb(213, 189, 128)",
    "rgb(188, 154, 82)",
    "rgb(184, 160, 110)",
    "rgb(174, 150, 104)",
    "rgb(219, 213, 179)",
    "rgb(194, 185, 141)",
    "rgb(167, 166, 109)",
    "rgb(232, 230, 190)",
    "rgb(212, 208, 144)",
    "rgb(179, 179, 107)",
    "rgb(111, 117, 59)",
    "rgb(96, 94, 58)",
    "rgb(168, 168, 136)",
    "rgb(187, 190, 154)",
    "rgb(201, 205, 174)",
    "rgb(163, 172, 136)",
    "rgb(118, 129, 107)",
    "rgb(73, 80, 51)",
    "rgb(55, 59, 51)",
    "rgb(164, 183, 147)",
    "rgb(119, 141, 111)",
    "rgb(90, 127, 96)",
    "rgb(63, 80, 52)",
    "rgb(39, 94, 66)",
    "rgb(81, 154, 111)",
    "rgb(111, 149, 135)",
    "rgb(47, 140, 127)",
    "rgb(68, 89, 82)",
    "rgb(191, 215, 206)",
    "rgb(151, 192, 185)",
    "rgb(86, 136, 136)",
    "rgb(62, 85, 90)",
    "rgb(112, 133, 135)",
    "rgb(209, 227, 225)",
    "rgb(127, 159, 161)",
    "rgb(149, 193, 199)",
    "rgb(106, 163, 172)",
    "rgb(94, 160, 183)",
    "rgb(109, 167, 197)",
    "rgb(61, 131, 160)",
    "rgb(70, 129, 169)",
    "rgb(51, 91, 126)",
    "rgb(49, 71, 87)",
    "rgb(207, 215, 209)",
    "rgb(168, 177, 170)",
    "rgb(119, 133, 132)",
    "rgb(199, 209, 211)",
    "rgb(173, 200, 213)",
    "rgb(130, 147, 156)",
    "rgb(91, 102, 109)",
    "rgb(82, 125, 143)",
    "rgb(66, 80, 88)",
    "rgb(56, 57, 58)",
    "rgb(88, 90, 91)",
    "rgb(95, 100, 100)",
    "rgb(127, 130, 130)",
    "rgb(164, 169, 169)",
    "rgb(145, 151, 153)",
    "rgb(214, 210, 200)",
    "rgb(186, 185, 175)",
    "rgb(128, 129, 123)",
];

export const metalColors = [
    "rgb(224, 224, 224)",
    "rgb(38, 22, 0)",
    "rgb(228, 199, 124)",
    "rgb(40, 40, 43)",
    "rgb(229, 229, 229)",
    "rgb(229, 193, 0)",
];

export const cabinetryColors = [
    "rgb(48, 56, 93)",
    "rgb(234, 239, 239)",
    "rgb(126, 136, 144)",
    "rgb(71, 49, 41)",
    "rgb(169, 151, 130)",
    "rgb(56, 100, 90)",
];

export const woodColors = [
    "rgb(118, 102, 89)",
    "rgb(197, 194, 195)",
    "rgb(142, 132, 115)",
    "rgb(138, 106, 81)",
    "rgb(217, 214, 201)",
    "rgb(217, 216, 212)",
    "rgb(214, 190, 158)",
    "rgb(162, 118, 85)",
    "rgb(176, 175, 171)",
    "rgb(181, 171, 158)",
    "rgb(105, 80, 51)",
];
